import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import DashboardTemplate from "../../Common/DashboardTemplate";
import {
    Checkbox,
    CircularProgress,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    TablePagination,
    InputAdornment
} from "@material-ui/core";
import axios from 'axios';
import {ServiceLocator} from "../../../Services/ServiceLocator";
import DrawerMenuRight from "../../Common/DrawerMenuRight";
import BulkAssignVehiclesDrawer from "./BulkAssignVehiclesDrawer";
import TextField from "@material-ui/core/TextField";
import {Button} from "@material-ui/core";
import { v4 as uuid } from 'uuid';
import Autocomplete from "@material-ui/lab/Autocomplete";
import FirstPageIcon from '@material-ui/icons/FirstPage';
import LastPageIcon from '@material-ui/icons/LastPage';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import Tooltip from "@material-ui/core/Tooltip";
import Zoom from "@material-ui/core/Zoom";
import { AuthenticationService } from "../../../Services/AuthenticationService";
import { filterPersistenceService } from "../../../Services/FilterPersistenceService";
import {parseNumberInputValue} from '../../../utils/numberInputUtils';
import PartDisplay from '../../Common/PartDisplay';
import PartAutocompleteOption from '../../Common/PartAutocompleteOption';
import SortableTableHeader from '../../Common/SortableTableHeader';
import {
    getNextSortState,
    applyCatalogDisplaySort,
    usesCatalogCategoryHeaders,
    sortPartsExpandedDefault,
    sortAssembliesExpandedDefault,
    sortSubAssembliesExpandedDefault,
} from '../../../utils/tableSortUtils';

const styles = theme => ({
    wrapper: {
        margin: -5,
    },
    filterToggle: {
        border: '1px solid #ccc',
        borderRadius: '4px',
        padding: '2px 10px',
        height: '36px',
        display: 'flex',
        alignItems: 'center',
        backgroundColor: 'transparent',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
        },
        minWidth: '150px',
        '& .MuiCheckbox-root': {
            padding: '0px',
            color: '#35d2d9',
            '&.Mui-checked': {
                color: '#35d2d9',
            },
        }
    },
    filterLabel: {
        marginLeft: '8px',
        fontSize: '14px',
        color: 'rgba(0, 0, 0, 0.87)',
    },
    toolbar: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    toolbarLeft: {
        display: 'flex',
        alignItems: 'center',
    },
    toolbarRight: {
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
    },
    title: {
        fontSize: '24px',
        fontWeight: 500,
        color: 'rgba(0, 0, 0, 0.87)',
    }
});

let editingAssembly;
let editingSubAssembly;

class AdminAssemblies extends Component {
    state = {
        loading: true,
        user: {},
        users: [],
        assemblies: [],
        subAssemblies: [],
        showAdvancedInfo: false,
        showSpareParts: false,
        showOldRevs: false,
        showDeactivated: false,
        searchTerm: '',
        assemblyMenuOpen: false,
        newAssemblyIsFG: true,
        newFamilyName: '',
        newFamilyDescription: '',
        page: 0,
        rowsPerPage: 100,
        selectedAssemblyType: '',
        selectedManufacturerFor: '',
        selectedTertiaryType: '',
        selectedBrand: '',
        editAssemblyTypeOpen: false,
        editManufacturerForOpen: false,
        editTertiaryTypeOpen: false,
        newAssemblyTypeValue: '',
        newManufacturerForValue: '',
        newTertiaryTypeValue: '',
        oldValue: '',
        savingCategory: false,
        newAssemblyType: false,
        newManufacturerFor: false,
        newTertiaryType: false,
        newSubAssemblyType: false,
        newSubManufacturerFor: false,
        newSubTertiaryType: false,
        // Multiselect functionality
        selectedAssemblies: {},
        lastSelectedIndex: null, // Track last clicked index for Shift+Click range selection
        isProcessingModifierClick: false, // Flag to prevent checkbox onChange during modifier clicks
        assignCategoryOpen: false,
        assignVehiclesOpen: false,
        // Primary category
        primaryCategoryValue: '',
        primaryCategoryNewValue: '',
        showNewPrimaryCategoryField: false,
        // Secondary category
        secondaryCategoryValue: '',
        secondaryCategoryNewValue: '',
        showNewSecondaryCategoryField: false,
        // Tertiary category
        tertiaryCategoryValue: '',
        tertiaryCategoryNewValue: '',
        showNewTertiaryCategoryField: false,
        // Brand
        brandValue: '',
        brandNewValue: '',
        showNewBrandField: false,
        // Input values for autocomplete
        primaryCategoryInputValue: '',
        secondaryCategoryInputValue: '',
        tertiaryCategoryInputValue: '',
        brandInputValue: '',
        // Data arrays
        discountStrategies: [],
        assemblyFamilies: [],
        sortField: null,
        sortDirection: 'asc',
    };

    handleChangePage = (event, newPage) => {
        this.setState({page: newPage}, () => {
            this.saveFilterSettings();
        });
    };

    handleChangeRowsPerPage = (event) => {
        this.setState({
            rowsPerPage: parseInt(event.target.value, 10),
            page: 0
        }, () => {
            this.saveFilterSettings();
        });
    };

    handleSort = (field) => {
        this.setState((prevState) => {
            const next = getNextSortState(prevState.sortField, prevState.sortDirection, field);
            return {
                sortField: next.field,
                sortDirection: next.direction,
                page: 0,
            };
        }, () => {
            this.saveFilterSettings();
        });
    };

    constructor(props) {
        super(props);
        globalProps = props;

        const jwtToken = AuthenticationService.getInstance().getToken();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + jwtToken;
    }

    componentDidMount() {
        this.loadSavedFilterSettings();
        this.loadData();
    }

    loadSavedFilterSettings = () => {
        const savedSettings = filterPersistenceService.loadFilterSettings('assemblies');
        if (savedSettings) {
            this.setState({
                page: savedSettings.page || 0,
                rowsPerPage: savedSettings.rowsPerPage || 100,
                selectedAssemblyType: savedSettings.selectedAssemblyType || '',
                selectedManufacturerFor: savedSettings.selectedManufacturerFor || '',
                selectedTertiaryType: savedSettings.selectedTertiaryType || '',
                selectedBrand: savedSettings.selectedBrand || '',
                showAdvancedInfo: savedSettings.showAdvancedInfo || false,
                showSpareParts: savedSettings.showSpareParts || false,
                showOldRevs: savedSettings.showOldRevs || false,
                showDeactivated: savedSettings.showDeactivated || false,
                searchTerm: savedSettings.searchTerm || ''
            });
        }
    }

    saveFilterSettings = () => {
        const settings = {
            page: this.state.page,
            rowsPerPage: this.state.rowsPerPage,
            selectedAssemblyType: this.state.selectedAssemblyType,
            selectedManufacturerFor: this.state.selectedManufacturerFor,
            selectedTertiaryType: this.state.selectedTertiaryType,
            selectedBrand: this.state.selectedBrand,
            showAdvancedInfo: this.state.showAdvancedInfo,
            showSpareParts: this.state.showSpareParts,
            showOldRevs: this.state.showOldRevs,
            showDeactivated: this.state.showDeactivated,
            searchTerm: this.state.searchTerm
        };
        filterPersistenceService.saveFilterSettings('assemblies', settings);
    }

    loadData = (forceClearCache = false) => {
        const self = this;
        const user = AuthenticationService.getInstance().getUser();
        if (!user || !user.userPermissions || !user.userPermissions.includes('Workshop')) {
            globalProps.history.push('/login');
            return;
        }

        self.setState({loading: true});
        Promise.all([self.loadAssemblies(), self.loadSubAssemblies(), self.loadDiscountStrategies(), self.loadAssemblyFamilies()]).then(() => {
            self.setState({loading: false, user, assembliesAndSubAssemblies: self.state.assemblies.concat(self.state.subAssemblies), permissions: user.userPermissions});
            // Focus search bar after render
            setTimeout(() => {
                if (this.searchInputRef) {
                    this.searchInputRef.focus();
                }
            }, 100);
        });
    };

    loadAssemblies = () => {
        const self = this;
        const assemblyService = ServiceLocator.Instance.getAssemblyService();

        return assemblyService.getAllAssembliesExpanded().then((assembliesResult) => {
            self.setState({assemblies: sortAssembliesExpandedDefault(assembliesResult)});
        });
    };

    loadSubAssemblies = () => {
        const self = this;
        const assemblyService = ServiceLocator.Instance.getAssemblyService();

        return assemblyService.getAllSubAssembliesExpanded().then((subAssembliesResult) => {
            self.setState({subAssemblies: sortSubAssembliesExpandedDefault(subAssembliesResult)});
        });
    };

    loadDiscountStrategies = () => {
        const self = this;
        const assemblyService = ServiceLocator.Instance.getAssemblyService();

        return assemblyService.getDiscountStrategies().then((discountStrategiesResult) => {
            self.setState({discountStrategies: discountStrategiesResult});
        });
    };

    loadAssemblyFamilies = () => {
        const self = this;
        const assemblyService = ServiceLocator.Instance.getAssemblyService();

        return assemblyService.getAssemblyFamilies().then((assemblyFamiliesResult) => {
            self.setState({assemblyFamilies: assemblyFamiliesResult});
        });
    };

    toggleAdvancedInfo = () => {
        const {showAdvancedInfo} = this.state;
        this.setState({showAdvancedInfo: !showAdvancedInfo}, () => {
            this.saveFilterSettings();
        });
    };

    toggleSpareParts = () => {
        const {showSpareParts} = this.state;
        this.setState({showSpareParts: !showSpareParts}, () => {
            this.saveFilterSettings();
        });
    };

    toggleOldRevs = () => {
        const {showOldRevs} = this.state;
        this.setState({showOldRevs: !showOldRevs}, () => {
            this.saveFilterSettings();
        });
    };

    toggleDeactivated = () => {
        const {showDeactivated} = this.state;
        this.setState({showDeactivated: !showDeactivated}, () => {
            this.saveFilterSettings();
        });
    };

    handleAssemblyTypeFilterChange = (event, newValue) => {
        this.setState({
            selectedAssemblyType: newValue || '',
            selectedManufacturerFor: '',
            selectedTertiaryType: '',
            page: 0
        }, () => {
            this.saveFilterSettings();
        });
    };

    handleManufacturerForFilterChange = (event, newValue) => {
        this.setState({
            selectedManufacturerFor: newValue ? newValue.subType : '',
            selectedTertiaryType: '',
            page: 0
        }, () => {
            this.saveFilterSettings();
        });
    };

    handleTertiaryTypeFilterChange = (event, newValue) => {
        this.setState({
            selectedTertiaryType: newValue || '',
            page: 0
        }, () => {
            this.saveFilterSettings();
        });
    };

    handleBrandFilterChange = (event, newValue) => {
        this.setState({
            selectedBrand: newValue || '',
            page: 0
        }, () => {
            this.saveFilterSettings();
        });
    };

    saveAssemblyType = () => {
        const self = this;
        const assemblyService = ServiceLocator.Instance.getAssemblyService();
        self.setState({savingCategory: true});
        assemblyService.updateAssemblyType(this.state.newAssemblyTypeValue, this.state.oldValue).then(() => {
            self.setState({savingCategory: false, editAssemblyTypeOpen: false, selectedAssemblyType: this.state.newAssemblyTypeValue});
            // Increased timeout to allow server cache invalidation
            setTimeout(() => {
                self.loadData();
                // Force a second reload to ensure cache is cleared
                setTimeout(() => self.loadData(), 1000);
            }, 1000);
        });
    };

    saveManufacturerFor = () => {
        const self = this;
        const assemblyService = ServiceLocator.Instance.getAssemblyService();
        self.setState({savingCategory: true});
        assemblyService.updateManufacturerFor(this.state.newManufacturerForValue, this.state.oldValue, this.state.selectedAssemblyType).then(() => {
            self.setState({savingCategory: false, editManufacturerForOpen: false, selectedManufacturerFor: this.state.newManufacturerForValue});
            // Increased timeout to allow server cache invalidation
            setTimeout(() => {
                self.loadData();
                // Force a second reload to ensure cache is cleared
                setTimeout(() => self.loadData(), 1000);
            }, 1000);
        });
    };

    saveTertiaryType = () => {
        const self = this;
        const assemblyService = ServiceLocator.Instance.getAssemblyService();
        self.setState({savingCategory: true});
        assemblyService.updateTertiaryCategory(this.state.newTertiaryTypeValue, this.state.oldValue).then(() => {
            self.setState({savingCategory: false, editTertiaryTypeOpen: false, selectedTertiaryType: this.state.newTertiaryTypeValue});
            // Increased timeout to allow server cache invalidation
            setTimeout(() => {
                self.loadData();
                // Force a second reload to ensure cache is cleared
                setTimeout(() => self.loadData(), 1000);
            }, 1000);
        });
    };

    handleAssemblyTypeHeaderClick = (assemblyType) => {
        // Don't allow editing empty/null categories
        if (!assemblyType || assemblyType.trim() === '') {
            return;
        }
        this.setState({
            editAssemblyTypeOpen: true,
            newAssemblyTypeValue: assemblyType,
            oldValue: assemblyType
        });
    };

    handleManufacturerForHeaderClick = (manufacturerFor) => {
        // Don't allow editing empty/null categories
        if (!manufacturerFor || manufacturerFor.trim() === '') {
            return;
        }
        this.setState({
            editManufacturerForOpen: true,
            newManufacturerForValue: manufacturerFor,
            oldValue: manufacturerFor
        });
    };

    handleTertiaryTypeHeaderClick = (tertiaryType) => {
        // Don't allow editing empty/null categories
        if (!tertiaryType || tertiaryType.trim() === '') {
            return;
        }
        this.setState({
            editTertiaryTypeOpen: true,
            newTertiaryTypeValue: tertiaryType,
            oldValue: tertiaryType
        });
    };

    searchAssembly = (event) => {
        const searchInput = event.target.value;
        this.setState({searchTerm: searchInput, page: 0}, () => {
            this.saveFilterSettings();
        });
    };

    openAssemblyMenu = () => {
        this.setState({assemblyMenuOpen: true});
    };

    handleCloseAssemblyMenu = () => {
        this.setState({assemblyMenuOpen: false});
    };

    createAssembly = () => {
        const self = this;
        editingAssembly = {
            assembly: {
                id: '',
                assemblyFamilyId: null,
                assemblyType: '',
                manufacturerFor: '',
                tertiaryType: '',
                assemblyId: '',
                revision: '',
                revisionNotes: '',
                description: '',
                imageURL: '',
                fileURLs: '',
                squarespaceURL: '',
                labelDescription: '',
                installVideoURL: '',
                weightPounds: 0,
                weightOunces: 0,
                shippingCost: 0.00,
                msrp: 0.00,
                discountTier1: 0.20,
                discountTier2: 0.25,
                discountTier3: 0.32,
                partsToAssemblies: [],
                subAssembliesToAssemblies: [],
                isActive: true,
                currentlyPackaging: true,
                spareBushingsSetId: null,
                spareBushingsSetQuantity: 0,
                spareHardwareSetId: null,
                spareHardwareSetQuantity: 0,
                isDiscontinued: false
            }
        };
        const matchingDiscountStrategy = this.state.discountStrategies.find(x => x.discountTier1 === editingAssembly.assembly.discountTier1 && x.discountTier2 === editingAssembly.assembly.discountTier2 && x.discountTier3 === editingAssembly.assembly.discountTier3);
        self.setState({editingAssembly, matchingDiscountStrategy, editAssemblyOpen: true, savingAssembly: false, assemblyMenuOpen: false, newAssemblyType: false, newManufacturerFor: false, newTertiaryType: false});
    };

    createSubAssembly = () => {
        const self = this;
        editingSubAssembly = {
            subAssembly: {
                id: '',
                assemblyType: '',
                manufacturerFor: '',
                tertiaryType: '',
                subAssemblyId: '',
                revision: '',
                revisionNotes: '',
                description: '',
                weightPounds: 0,
                weightOunces: 0,
                imageURL: '',
                fileURLs: '',
                partsToSubAssemblies: [],
                isActive: true,
                currentlyPackaging: true,
                childSubAssemblies: [],
                parentSubAssemblies: []
            }
        };
        self.setState({editingSubAssembly, editSubAssemblyOpen: true, savingSubAssembly: false, assemblyMenuOpen: false, newAssemblyType: false, newManufacturerFor: false, newTertiaryType: false});
    };

    handleRowClick = (e, assembly) => {
        const self = this;
        if (!self.state.permissions.includes('EditAssembliesAndParts')) return;
        switch (e.detail) {
            case 2:
                self.editAssembly(assembly, e.ctrlKey);
                break;
            default:
                break;
        }
    };

    editAssembly = (assemblyExpanded, newTab) => {
        if (newTab)
            window.open(`/admin/assemblies/${assemblyExpanded.assembly ? assemblyExpanded.assembly.id : assemblyExpanded.subAssembly.id}`);
        else
            globalProps.history.push(`/admin/assemblies/${assemblyExpanded.assembly ? assemblyExpanded.assembly.id : assemblyExpanded.subAssembly.id}`);
    };

    changeNewFamilyName = (event) => {
        this.setState({newFamilyName: event.target.value});
    };

    changeNewFamilyDescription = (event) => {
        this.setState({newFamilyDescription: event.target.value});
    };

    changeAssemblyTypeSelection = (event, newValue) => {
        const self = this;
        if (!newValue || newValue === 'New...') {
            editingAssembly.assembly.assemblyType = !newValue ? '' : newValue;
            self.setState({editingAssembly, newAssemblyType: true});
        } else {
            editingAssembly.assembly.assemblyType = newValue;
            self.setState({editingAssembly, newAssemblyType: false});
        }
    };

    changeAssemblyType = (event) => {
        const self = this;
        editingAssembly.assembly.assemblyType = event.target.value;
        self.setState({editingAssembly});
    };

    changeManufacturerForSelection = (event, newValue) => {
        const self = this;
        if (!newValue || newValue.subType === 'New...') {
            editingAssembly.assembly.manufacturerFor = !newValue ? '' : newValue.subType;
            self.setState({editingAssembly, newManufacturerFor: true});
        } else {
            editingAssembly.assembly.manufacturerFor = newValue.subType;
            self.setState({editingAssembly, newManufacturerFor: false});
        }
    };

    changeManufacturerFor = (event) => {
        const self = this;
        editingAssembly.assembly.manufacturerFor = event.target.value;
        self.setState({editingAssembly});
    };

    changeTertiaryTypeSelection = (event, newValue) => {
        const self = this;
        if (!newValue || newValue === 'New...') {
            editingAssembly.assembly.tertiaryType = !newValue ? '' : newValue;
            self.setState({editingAssembly, newTertiaryType: true});
        } else {
            editingAssembly.assembly.tertiaryType = newValue;
            self.setState({editingAssembly, newTertiaryType: false});
        }
    };

    changeTertiaryType = (event) => {
        const self = this;
        editingAssembly.assembly.tertiaryType = event.target.value;
        self.setState({editingAssembly});
    };

    changeAssemblyId = (event) => {
        editingAssembly.assembly.assemblyId = event.target.value;
        this.setState({editingAssembly});
    };

    changeRevision = (event) => {
        editingAssembly.assembly.revision = event.target.value;
        this.setState({editingAssembly});
    };

    changeRevisionNotes = (event) => {
        editingAssembly.assembly.revisionNotes = event.target.value;
        this.setState({editingAssembly});
    };

    changeDescription = (event) => {
        editingAssembly.assembly.description = event.target.value;
        this.setState({editingAssembly});
    };

    handleAssemblyStatusChange = (status) => {
        editingAssembly.assembly.status = status;
        this.setState({editingAssembly});
    };

    changeShippingCost = (event) => {
        editingAssembly.assembly.shippingCost = event.target.value;
        this.setState({editingAssembly});
    };

    changeMSRP = (event) => {
        editingAssembly.assembly.msrp = event.target.value;
        this.setState({editingAssembly});
    };

    handleAssemblyFamilyChange = (event, newValue) => {
        if (!newValue) this.setState({assemblyFamily: null});
        else {
            const matchingFamily = this.state.assemblyFamilies.find(x => x.id === newValue.value);
            if (!matchingFamily) {
                this.setState({assemblyFamily: 'New'});
            } else {
                editingAssembly.assembly.assemblyFamilyId = matchingFamily.id;
                this.setState({editingAssembly, matchingFamily, assemblyFamily: newValue.value});
            }
        }
    };

    handleDiscountStrategyChange = (event, newValue) => {
        if (!newValue) this.setState({discountStrategy: null});
        else {
            const matchingDiscountStrategy = this.state.discountStrategies.find(x => x.id === newValue.value);
            editingAssembly.assembly.discountTier1 = matchingDiscountStrategy.discountTier1;
            editingAssembly.assembly.discountTier2 = matchingDiscountStrategy.discountTier2;
            editingAssembly.assembly.discountTier3 = matchingDiscountStrategy.discountTier3;
            this.setState({editingAssembly, matchingDiscountStrategy, discountStrategy: newValue.value});
        }
    };

    changeDiscountTier1 = (event) => {
        editingAssembly.assembly.discountTier1 = event.target.value > 1.00 ? event.target.value / 100 : event.target.value;
        const matchingDiscountStrategy = this.state.discountStrategies.find(x => x.discountTier1 === editingAssembly.assembly.discountTier1 && x.discountTier2 === editingAssembly.assembly.discountTier2 && x.discountTier3 === editingAssembly.assembly.discountTier3);
        this.setState({matchingDiscountStrategy, editingAssembly});
    };

    changeDiscountTier2 = (event) => {
        editingAssembly.assembly.discountTier2 = event.target.value > 1.00 ? event.target.value / 100 : event.target.value;
        const matchingDiscountStrategy = this.state.discountStrategies.find(x => x.discountTier1 === editingAssembly.assembly.discountTier1 && x.discountTier2 === editingAssembly.assembly.discountTier2 && x.discountTier3 === editingAssembly.assembly.discountTier3);
        this.setState({matchingDiscountStrategy, editingAssembly});
    };

    changeDiscountTier3 = (event) => {
        editingAssembly.assembly.discountTier3 = event.target.value > 1.00 ? event.target.value / 100 : event.target.value;
        const matchingDiscountStrategy = this.state.discountStrategies.find(x => x.discountTier1 === editingAssembly.assembly.discountTier1 && x.discountTier2 === editingAssembly.assembly.discountTier2 && x.discountTier3 === editingAssembly.assembly.discountTier3);
        this.setState({matchingDiscountStrategy, editingAssembly});
    };

    saveAssembly = () => {
        const self = this;
        self.setState({savingAssembly: true});
        const assemblyService = ServiceLocator.Instance.getAssemblyService();

        const familyPayload = {
            id: uuid(),
            assemblyFamilyId: this.state.newFamilyName,
            description: this.state.newFamilyDescription
        };
        if (this.state.newFamilyName !== '') {
            editingAssembly.assembly.assemblyFamilyId = familyPayload.id;
            editingAssembly.assembly.assemblyFamily = familyPayload;
        }

        if (editingAssembly.assembly.id === '') {
            editingAssembly.assembly.id = uuid();
            if (this.state.assemblies.find(x => x.assembly.assemblyId.toLowerCase().trim() === editingAssembly.assembly.assemblyId.toLowerCase().trim() && x.assembly.revision.toLowerCase().trim() === editingAssembly.assembly.revision.toLowerCase().trim()) || this.state.subAssemblies.find(x => x.subAssembly.subAssemblyId.toLowerCase().trim() === editingAssembly.assembly.assemblyId.toLowerCase().trim() && x.subAssembly.revision.toLowerCase().trim() === editingAssembly.assembly.revision.toLowerCase().trim())) {
                self.setState({savingAssembly: false});
                return window.$alertWarning("An assembly already exists with that Part Number and Revision!");
            } else {
                const assemblyToCreate = {
                    ...editingAssembly.assembly,
                    shippingCost: parseNumberInputValue(editingAssembly.assembly.shippingCost),
                    msrp: parseNumberInputValue(editingAssembly.assembly.msrp),
                    isDiscontinued: editingAssembly.assembly.isDiscontinued || false
                };
                assemblyService.createAssembly(assemblyToCreate).then((newAssembly) => {
                    window.$alertSuccess("Assembly created");
                    self.setState({
                        editAssemblyOpen: false,
                        savingAssembly: false,
                        assemblyFamily: null,
                        newFamilyName: '',
                        newFamilyDescription: ''
                    });
                    // Redirect to the edit page for the newly created assembly
                    globalProps.history.push(`/admin/assemblies/${newAssembly.id}`);
                });
            }
        } else {
            editingAssembly.assembly.partsToAssemblies = [];
            editingAssembly.assembly.subAssembliesToAssemblies = [];
                const assemblyToUpdate = {
                    ...editingAssembly.assembly,
                    shippingCost: parseNumberInputValue(editingAssembly.assembly.shippingCost),
                    msrp: parseNumberInputValue(editingAssembly.assembly.msrp),
                    isDiscontinued: editingAssembly.assembly.isDiscontinued || false
                };
                assemblyService.updateAssembly(assemblyToUpdate).then((part) => {
                window.$alertSuccess("Assembly updated");
                self.setState({editAssemblyOpen: false, savingAssembly: false, assemblyFamily: null, newFamilyName: '', newFamilyDescription: ''});
                self.loadData();
            });
        }
    };

    deleteAssembly = () => {
        const confirm = window.confirm("Are you sure you want to deactivate this assembly?");
        if (!confirm) return;

        const self = this;
        const assemblyService = ServiceLocator.Instance.getAssemblyService();
        editingAssembly.assembly.partsToAssemblies = [];
        editingAssembly.assembly.subAssembliesToAssemblies = [];
        editingAssembly.assembly.isActive = false;
            const assemblyToUpdate = {
                ...editingAssembly.assembly,
                shippingCost: parseNumberInputValue(editingAssembly.assembly.shippingCost),
                msrp: parseNumberInputValue(editingAssembly.assembly.msrp),
                isDiscontinued: editingAssembly.assembly.isDiscontinued || false
            };
            assemblyService.updateAssembly(assemblyToUpdate).then(() => {
            window.$alertSuccess("Assembly deactivated");
            self.setState({editAssemblyOpen: false, savingAssembly: false});
            self.loadData();
        });
    };

    handleCloseEditAssembly = () => {
        this.setState({editingAssembly: null, editAssemblyOpen: false});
    };

    hasEditAssemblyUnsavedChanges = () => {
        if (!this.state.editingAssembly) return false;
        
        const assembly = this.state.editingAssembly.assembly;
        
        // Check if this is a new assembly (no ID) and any field has been filled
        const isNewAssembly = assembly.id === '';
        if (isNewAssembly) {
            const hasContent = (
                assembly.assemblyId !== '' ||
                assembly.revision !== '' ||
                assembly.revisionNotes !== '' ||
                assembly.description !== '' ||
                assembly.shippingCost !== 0.00 ||
                assembly.msrp !== 0.00 ||
                assembly.assemblyFamilyId !== null
            );
            if (hasContent) return true;
        }
        
        // Check other UI state changes
        return (
            this.state.assemblyFamily === 'New' ||
            this.state.newFamilyName !== '' ||
            this.state.newFamilyDescription !== '' ||
            this.state.newAssemblyType === true ||
            this.state.newManufacturerFor === true ||
            this.state.newTertiaryType === true
        );
    };

    changeSubAssemblyTypeSelection = (event, newValue) => {
        const self = this;
        if (!newValue || newValue === 'New...') {
            editingSubAssembly.subAssembly.assemblyType = !newValue ? '' : newValue;
            self.setState({editingSubAssembly, newAssemblyType: true});
        } else {
            editingSubAssembly.subAssembly.assemblyType = newValue;
            self.setState({editingSubAssembly, newAssemblyType: false});
        }
    };

    changeSubAssemblyType = (event) => {
        const self = this;
        editingSubAssembly.subAssembly.assemblyType = event.target.value;
        self.setState({editingSubAssembly});
    };

    changeSubManufacturerForSelection = (event, newValue) => {
        const self = this;
        if (!newValue || newValue.subType === 'New...') {
            editingSubAssembly.subAssembly.manufacturerFor = !newValue ? '' : newValue.subType;
            self.setState({editingSubAssembly, newManufacturerFor: true});
        } else {
            editingSubAssembly.subAssembly.manufacturerFor = newValue.subType;
            self.setState({editingSubAssembly, newManufacturerFor: false});
        }
    };

    changeSubManufacturerFor = (event) => {
        const self = this;
        editingSubAssembly.subAssembly.manufacturerFor = event.target.value;
        self.setState({editingSubAssembly});
    };

    changeSubTertiaryTypeSelection = (event, newValue) => {
        const self = this;
        if (!newValue || newValue === 'New...') {
            editingSubAssembly.subAssembly.tertiaryType = !newValue ? '' : newValue;
            self.setState({editingSubAssembly, newTertiaryType: true});
        } else {
            editingSubAssembly.subAssembly.tertiaryType = newValue;
            self.setState({editingSubAssembly, newTertiaryType: false});
        }
    };

    changeSubTertiaryType = (event) => {
        const self = this;
        editingSubAssembly.subAssembly.tertiaryType = event.target.value;
        self.setState({editingSubAssembly});
    };

    changeSubAssemblyId = (event) => {
        editingSubAssembly.subAssembly.subAssemblyId = event.target.value;
        this.setState({editingSubAssembly});
    };

    changeSubRevision = (event) => {
        editingSubAssembly.subAssembly.revision = event.target.value;
        this.setState({editingSubAssembly});
    };

    changeSubRevisionNotes = (event) => {
        editingSubAssembly.subAssembly.revisionNotes = event.target.value;
        this.setState({editingSubAssembly});
    };

    changeSubDescription = (event) => {
        editingSubAssembly.subAssembly.description = event.target.value;
        this.setState({editingSubAssembly});
    };

    saveSubAssembly = () => {
        const self = this;
        self.setState({savingSubAssembly: true});
        const assemblyService = ServiceLocator.Instance.getAssemblyService();
        if (editingSubAssembly.subAssembly.id === '') {
            editingSubAssembly.subAssembly.id = uuid();
            if (this.state.subAssemblies.find(x => x.subAssembly.subAssemblyId.toLowerCase().trim() === editingSubAssembly.subAssembly.subAssemblyId.toLowerCase().trim() && x.subAssembly.revision.toLowerCase().trim() === editingSubAssembly.subAssembly.revision.toLowerCase().trim()) || this.state.assemblies.find(x => x.assembly.assemblyId.toLowerCase().trim() === editingSubAssembly.subAssembly.subAssemblyId.toLowerCase().trim() && x.assembly.revision.toLowerCase().trim() === editingSubAssembly.subAssembly.revision.toLowerCase().trim())) {
                self.setState({savingSubAssembly: false});
                return window.$alertWarning("An assembly already exists with that Part Number and Revision!");
            } else {
                assemblyService.createSubAssembly(editingSubAssembly.subAssembly).then((newSubAssembly) => {
                    window.$alertSuccess("Assembly created");
                    self.setState({editSubAssemblyOpen: false, savingSubAssembly: false});
                    // Redirect to the edit page for the newly created subassembly
                    globalProps.history.push(`/admin/assemblies/${newSubAssembly.id}`);
                });
            }
        } else {
            editingSubAssembly.subAssembly.partsToSubAssemblies = [];
            assemblyService.updateSubAssembly(this.state.editingSubAssembly.subAssembly).then((subAssembly) => {
                window.$alertSuccess("Assembly updated");
                self.setState({editSubAssemblyOpen: false, savingSubAssembly: false});
                self.loadData();
            });
        }
    };

    deleteSubAssembly = () => {
        const confirm = window.confirm("Are you sure you want to  subassembly?");
        if (!confirm) return;

        const self = this;
        const assemblyService = ServiceLocator.Instance.getAssemblyService();
        editingSubAssembly.subAssembly.partsToSubAssemblies = [];
        editingSubAssembly.subAssembly.isActive = false;
        assemblyService.updateSubAssembly(editingSubAssembly.subAssembly).then(() => {
            window.$alertSuccess("Assembly deleted");
            self.setState({editSubAssemblyOpen: false, savingSubAssembly: false});
            self.loadData();
        });
    };

    handleCloseEditSubAssembly = () => {
        this.setState({editingSubAssembly: null, editSubAssemblyOpen: false});
    };

    hasEditSubAssemblyUnsavedChanges = () => {
        if (!this.state.editingSubAssembly) return false;
        
        const subAssembly = this.state.editingSubAssembly.subAssembly;
        
        // Check if this is a new subassembly (no ID) and any field has been filled
        const isNewSubAssembly = subAssembly.id === '';
        if (isNewSubAssembly) {
            const hasContent = (
                subAssembly.subAssemblyId !== '' ||
                subAssembly.revision !== '' ||
                subAssembly.revisionNotes !== '' ||
                subAssembly.description !== ''
            );
            if (hasContent) return true;
        }
        
        // Check other UI state changes
        return (
            this.state.newAssemblyType === true ||
            this.state.newManufacturerFor === true ||
            this.state.newTertiaryType === true
        );
    };

    // Multiselect functionality
    handleAssemblySelection = (assemblyId, event) => {
        // Get filtered assemblies array for range selection (same logic as render)
        const filteredAssembliesAndSubAssemblies = this.state.assembliesAndSubAssemblies.filter(x => {
            const assembly = x.assembly || x.subAssembly;
            const isAssembly = !!x.assembly;
            
            const isActiveFilter = (assembly && assembly.isActive === true) || this.state.showDeactivated;
            const assemblyTypeFilter = !this.state.selectedAssemblyType || assembly.assemblyType === this.state.selectedAssemblyType;
            const manufacturerForFilter = !this.state.selectedManufacturerFor || assembly.manufacturerFor === this.state.selectedManufacturerFor;
            const tertiaryTypeFilter = !this.state.selectedTertiaryType || assembly.tertiaryType === this.state.selectedTertiaryType;
            const brandFilter = !this.state.selectedBrand || assembly.brand === this.state.selectedBrand;
            
            // Check if currently packaging or currently shipping
            const isCurrentlyPackaging = assembly.currentlyPackaging === true;
            const isCurrentlyShipping = isAssembly && !assembly.finalOrderNumber;
            const isCurrentRevision = isCurrentlyPackaging || isCurrentlyShipping;
            
            // Include old revisions only if showOldRevs is true
            const revisionFilter = this.state.showOldRevs || isCurrentRevision;
            
            // Apply search filter
            let searchFilter = true;
            if (this.state.searchTerm) {
                const searchTerms = this.state.searchTerm.split(' ').filter(term => term.trim() !== '');
                if (searchTerms.length > 0) {
                    searchFilter = searchTerms.every(term => {
                        const searchTerm = term.toLowerCase();
                        const partId = isAssembly ? assembly.assemblyId : assembly.subAssemblyId;
                        return (
                            (partId && partId.toLowerCase().includes(searchTerm)) ||
                            (assembly.description && assembly.description.toLowerCase().includes(searchTerm)) ||
                            (assembly.assemblyType && assembly.assemblyType.toLowerCase().includes(searchTerm)) ||
                            (assembly.manufacturerFor && assembly.manufacturerFor.toLowerCase().includes(searchTerm)) ||
                            (assembly.brand && assembly.brand.toLowerCase().includes(searchTerm))
                        );
                    });
                }
            }
            
            return isActiveFilter && assemblyTypeFilter && manufacturerForFilter && tertiaryTypeFilter && brandFilter && revisionFilter && searchFilter;
        });

        const currentIndex = filteredAssembliesAndSubAssemblies.findIndex(a => {
            const assembly = a.assembly || a.subAssembly;
            return assembly.id === assemblyId;
        });
        const isCurrentlySelected = !!this.state.selectedAssemblies[assemblyId];
        
        // Check for modifier keys
        const isCtrlPressed = (event && (event.ctrlKey || event.metaKey)) || 
                             (event.nativeEvent && (event.nativeEvent.ctrlKey || event.nativeEvent.metaKey));
        const isShiftPressed = (event && event.shiftKey) || 
                               (event.nativeEvent && event.nativeEvent.shiftKey);
        
        // Set flag to prevent checkbox onChange from processing modifier clicks
        const hasModifiers = isCtrlPressed || isShiftPressed;
        if (hasModifiers) {
            this.setState({ isProcessingModifierClick: true });
            if (event && event.preventDefault) event.preventDefault();
            if (event && event.stopPropagation) event.stopPropagation();
        }
        
        if (currentIndex === -1) {
            // Assembly not found in filtered data, fall back to simple toggle
            const selectedAssemblies = { ...this.state.selectedAssemblies };
            if (isCurrentlySelected) {
                delete selectedAssemblies[assemblyId];
            } else {
                selectedAssemblies[assemblyId] = true;
            }
            this.setState({ 
                selectedAssemblies,
                lastSelectedIndex: null
            });
            if (hasModifiers) {
                setTimeout(() => {
                    this.setState({ isProcessingModifierClick: false });
                }, 100);
            }
            return;
        }

        if (isShiftPressed && this.state.lastSelectedIndex !== null && this.state.lastSelectedIndex !== -1) {
            // Shift+Click: Select range from lastSelectedIndex to currentIndex
            const startIndex = Math.min(this.state.lastSelectedIndex, currentIndex);
            const endIndex = Math.max(this.state.lastSelectedIndex, currentIndex);
            const rangeIds = filteredAssembliesAndSubAssemblies.slice(startIndex, endIndex + 1).map(a => {
                const assembly = a.assembly || a.subAssembly;
                return assembly.id;
            });
            
            if (isCtrlPressed) {
                // Ctrl+Shift+Click: Toggle range selection
                const allInRangeSelected = rangeIds.every(id => !!this.state.selectedAssemblies[id]);
                const selectedAssemblies = { ...this.state.selectedAssemblies };
                if (allInRangeSelected) {
                    // Remove all items in range
                    rangeIds.forEach(id => delete selectedAssemblies[id]);
                } else {
                    // Add all items in range
                    rangeIds.forEach(id => selectedAssemblies[id] = true);
                }
                this.setState({
                    selectedAssemblies,
                    lastSelectedIndex: currentIndex
                });
            } else {
                // Shift+Click: Add range, or remove range when anchor/range indicates deselection flow
                const selectedAssemblies = { ...this.state.selectedAssemblies };
                const anchorEntry = filteredAssembliesAndSubAssemblies[this.state.lastSelectedIndex];
                const anchorAssembly = anchorEntry?.assembly || anchorEntry?.subAssembly;
                const anchorId = anchorAssembly?.id;
                const anchorIsSelected = anchorId ? !!this.state.selectedAssemblies[anchorId] : true;
                const allInRangeSelected = rangeIds.every(id => !!this.state.selectedAssemblies[id]);
                const shouldDeselectRange = !anchorIsSelected || (isCurrentlySelected && allInRangeSelected);

                if (shouldDeselectRange) {
                    rangeIds.forEach(id => delete selectedAssemblies[id]);
                } else {
                    rangeIds.forEach(id => selectedAssemblies[id] = true);
                }

                this.setState({
                    selectedAssemblies,
                    lastSelectedIndex: currentIndex
                });
            }
        } else if (isCtrlPressed) {
            // Ctrl+Click: Toggle individual item
            const selectedAssemblies = { ...this.state.selectedAssemblies };
            if (isCurrentlySelected) {
                delete selectedAssemblies[assemblyId];
            } else {
                selectedAssemblies[assemblyId] = true;
            }
            this.setState({
                selectedAssemblies,
                lastSelectedIndex: currentIndex
            });
        } else {
            // Normal click: Simple toggle
            const selectedAssemblies = { ...this.state.selectedAssemblies };
            if (isCurrentlySelected) {
                delete selectedAssemblies[assemblyId];
            } else {
                selectedAssemblies[assemblyId] = true;
            }
            this.setState({
                selectedAssemblies,
                lastSelectedIndex: currentIndex
            });
        }
        
        // Clear the modifier flag after a short delay
        if (hasModifiers) {
            setTimeout(() => {
                this.setState({ isProcessingModifierClick: false });
            }, 100);
        }
    };

    deselectAllAssemblies = () => {
        this.setState({ selectedAssemblies: {} });
    };

    // Maps selected ids to fitment products, resolving whether each is an Assembly or Subassembly.
    getSelectedVehicleProducts = () => {
        const ids = Object.keys(this.state.selectedAssemblies || {});
        const assemblyIds = new Set((this.state.assemblies || []).map(x => x.assembly && x.assembly.id));
        return ids.map(id => ({
            productType: assemblyIds.has(id) ? 'Assembly' : 'Subassembly',
            productId: id
        }));
    };

    openAssignCategory = () => {
        this.setState({
            assignCategoryOpen: true,
            primaryCategoryValue: '',
            primaryCategoryNewValue: '',
            showNewPrimaryCategoryField: false,
            secondaryCategoryValue: '',
            secondaryCategoryNewValue: '',
            showNewSecondaryCategoryField: false,
            tertiaryCategoryValue: '',
            tertiaryCategoryNewValue: '',
            showNewTertiaryCategoryField: false,
            brandValue: '',
            brandNewValue: '',
            showNewBrandField: false
        });
    };

    closeAssignCategory = () => {
        this.setState({
            assignCategoryOpen: false,
            primaryCategoryValue: '',
            primaryCategoryInputValue: '',
            primaryCategoryNewValue: '',
            showNewPrimaryCategoryField: false,
            secondaryCategoryValue: '',
            secondaryCategoryInputValue: '',
            secondaryCategoryNewValue: '',
            showNewSecondaryCategoryField: false,
            tertiaryCategoryValue: '',
            tertiaryCategoryInputValue: '',
            tertiaryCategoryNewValue: '',
            showNewTertiaryCategoryField: false,
            brandValue: '',
            brandInputValue: '',
            brandNewValue: '',
            showNewBrandField: false
        });
    };

    getCategoryOptions = (categoryType) => {
        let assemblyTypeOptions = [];
        let manufacturerForOptions = [];
        let tertiaryTypeOptions = [];
        let brandOptions = [];
        
        // Collect options from assemblies
        this.state.assemblies.filter(x => x.assembly.isActive).forEach((assembly) => {
            if (assembly.assembly.assemblyType !== '' && !assemblyTypeOptions.includes(assembly.assembly.assemblyType))
                assemblyTypeOptions.push(assembly.assembly.assemblyType);
            if (assembly.assembly.manufacturerFor !== '' && !manufacturerForOptions.includes(assembly.assembly.manufacturerFor))
                manufacturerForOptions.push(assembly.assembly.manufacturerFor);
            if (assembly.assembly.tertiaryType && assembly.assembly.tertiaryType !== '' && !tertiaryTypeOptions.includes(assembly.assembly.tertiaryType))
                tertiaryTypeOptions.push(assembly.assembly.tertiaryType);
            if (assembly.assembly.brand && assembly.assembly.brand !== '' && !brandOptions.includes(assembly.assembly.brand))
                brandOptions.push(assembly.assembly.brand);
        });
        
        // Collect options from sub-assemblies
        this.state.subAssemblies.filter(x => x.subAssembly.isActive).forEach((subAssembly) => {
            if (subAssembly.subAssembly.assemblyType !== '' && !assemblyTypeOptions.includes(subAssembly.subAssembly.assemblyType))
                assemblyTypeOptions.push(subAssembly.subAssembly.assemblyType);
            if (subAssembly.subAssembly.manufacturerFor !== '' && !manufacturerForOptions.includes(subAssembly.subAssembly.manufacturerFor))
                manufacturerForOptions.push(subAssembly.subAssembly.manufacturerFor);
            if (subAssembly.subAssembly.tertiaryType && subAssembly.subAssembly.tertiaryType !== '' && !tertiaryTypeOptions.includes(subAssembly.subAssembly.tertiaryType))
                tertiaryTypeOptions.push(subAssembly.subAssembly.tertiaryType);
            if (subAssembly.subAssembly.brand && subAssembly.subAssembly.brand !== '' && !brandOptions.includes(subAssembly.subAssembly.brand))
                brandOptions.push(subAssembly.subAssembly.brand);
        });
        
        assemblyTypeOptions = assemblyTypeOptions.sort();
        manufacturerForOptions = manufacturerForOptions.sort();
        tertiaryTypeOptions = tertiaryTypeOptions.sort();
        brandOptions = brandOptions.sort();

        switch (categoryType) {
            case 'primary':
                return ['New...'].concat(assemblyTypeOptions);
            case 'secondary':
                return ['New...'].concat(manufacturerForOptions);
            case 'tertiary':
                return ['New...'].concat(tertiaryTypeOptions);
            case 'brand':
                return ['New...'].concat(brandOptions);
            default:
                return ['New...'];
        }
    };

    saveAssignCategory = async () => {
        const selectedAssemblyIds = Object.keys(this.state.selectedAssemblies);
        if (selectedAssemblyIds.length === 0) return;

        // Get the final values for each category
        const primaryValue = this.state.showNewPrimaryCategoryField ? this.state.primaryCategoryNewValue : this.state.primaryCategoryValue;
        const secondaryValue = this.state.showNewSecondaryCategoryField ? this.state.secondaryCategoryNewValue : this.state.secondaryCategoryValue;
        const tertiaryValue = this.state.showNewTertiaryCategoryField ? this.state.tertiaryCategoryNewValue : this.state.tertiaryCategoryValue;
        const brandValue = this.state.showNewBrandField ? this.state.brandNewValue : this.state.brandValue;

        // Check if at least one category is specified
        if (!primaryValue && !secondaryValue && !tertiaryValue && !brandValue) {
            window.$alertError('Please specify at least one category or brand');
            return;
        }

        this.setState({ savingCategory: true });

        try {
            const assemblyService = ServiceLocator.Instance.getAssemblyService();
            
            // Update each selected assembly/subassembly with the new categories
            for (const assemblyId of selectedAssemblyIds) {
                const assemblyExpanded = this.state.assemblies.find(a => a.assembly.id === assemblyId);
                const subAssemblyExpanded = this.state.subAssemblies.find(s => s.subAssembly.id === assemblyId);
                
                if (assemblyExpanded) {
                    const updatedAssembly = { ...assemblyExpanded.assembly };
                    
                    // Update categories only if they were specified
                    if (primaryValue) {
                        updatedAssembly.assemblyType = primaryValue;
                    }
                    if (secondaryValue) {
                        updatedAssembly.manufacturerFor = secondaryValue;
                    }
                    if (tertiaryValue) {
                        updatedAssembly.tertiaryType = tertiaryValue;
                    }
                    if (brandValue) {
                        updatedAssembly.brand = brandValue;
                    }
                    
                    await assemblyService.updateAssembly(updatedAssembly);
                } else if (subAssemblyExpanded) {
                    const updatedSubAssembly = { ...subAssemblyExpanded.subAssembly };
                    
                    // Update categories only if they were specified
                    if (primaryValue) {
                        updatedSubAssembly.assemblyType = primaryValue;
                    }
                    if (secondaryValue) {
                        updatedSubAssembly.manufacturerFor = secondaryValue;
                    }
                    if (tertiaryValue) {
                        updatedSubAssembly.tertiaryType = tertiaryValue;
                    }
                    if (brandValue) {
                        updatedSubAssembly.brand = brandValue;
                    }
                    
                    await assemblyService.updateSubAssembly(updatedSubAssembly);
                }
            }

            // Reload data and close drawer
            await this.loadData();
            this.setState({ 
                selectedAssemblies: {},
                assignCategoryOpen: false,
                savingCategory: false,
                primaryCategoryValue: '',
                primaryCategoryInputValue: '',
                primaryCategoryNewValue: '',
                showNewPrimaryCategoryField: false,
                secondaryCategoryValue: '',
                secondaryCategoryInputValue: '',
                secondaryCategoryNewValue: '',
                showNewSecondaryCategoryField: false,
                tertiaryCategoryValue: '',
                tertiaryCategoryInputValue: '',
                tertiaryCategoryNewValue: '',
                showNewTertiaryCategoryField: false,
                brandValue: '',
                brandInputValue: '',
                brandNewValue: '',
                showNewBrandField: false
            });
            
            const categoryNames = [];
            if (primaryValue) categoryNames.push('Primary');
            if (secondaryValue) categoryNames.push('Secondary');
            if (tertiaryValue) categoryNames.push('Tertiary');
            if (brandValue) categoryNames.push('Brand');
            
            window.$alertSuccess(`Updated ${categoryNames.join(', ')} for ${selectedAssemblyIds.length} assemblies successfully`);
        } catch (error) {
            console.error('Error updating assemblies:', error);
            window.$alertError('Failed to update assemblies');
            this.setState({ savingCategory: false });
        }
    };

    handleOpenAssignCategory = () => {
        this.setState({
            assignCategoryOpen: true,
            primaryCategoryValue: '',
            primaryCategoryInputValue: '',
            primaryCategoryNewValue: '',
            showNewPrimaryCategoryField: false,
            secondaryCategoryValue: '',
            secondaryCategoryInputValue: '',
            secondaryCategoryNewValue: '',
            showNewSecondaryCategoryField: false,
            tertiaryCategoryValue: '',
            tertiaryCategoryInputValue: '',
            tertiaryCategoryNewValue: '',
            showNewTertiaryCategoryField: false
        });
    };

    // Helper method to determine which assembly revision is currently selling
    getCurrentlySellingAssemblyId = (assemblyId) => {
        // Get all assemblies with the same assemblyId that don't have a finalOrderNumber
        const assembliesWithoutFinalOrder = this.state.assemblies.filter(assembly => 
            assembly.assembly.assemblyId === assemblyId && 
            !assembly.assembly.finalOrderNumber
        );
        
        // If only one assembly without finalOrderNumber, it's the currently selling one
        if (assembliesWithoutFinalOrder.length === 1) {
            return assembliesWithoutFinalOrder[0].assembly.id;
        }
        
        // If multiple assemblies without finalOrderNumber, find the one with the lowest revision
        if (assembliesWithoutFinalOrder.length > 1) {
            // Sort by revision (ascending) and return the lowest
            const sortedAssemblies = assembliesWithoutFinalOrder.sort((a, b) => {
                const revisionA = a.assembly.revision || '';
                const revisionB = b.assembly.revision || '';
                return revisionA.localeCompare(revisionB, undefined, { numeric: true, sensitivity: 'base' });
            });
            return sortedAssemblies[0].assembly.id;
        }
        
        // If no assemblies without finalOrderNumber, return null
        return null;
    };

    // Helper method to check if a specific assembly is currently selling
    isAssemblyCurrentlySelling = (assembly) => {
        if (!assembly || assembly.finalOrderNumber) {
            return false;
        }
        
        const currentlySellingId = this.getCurrentlySellingAssemblyId(assembly.assemblyId);
        return currentlySellingId === assembly.id;
    };

    render() {
        const {classes} = this.props;
        const self = this;
        if (this.state.loading) {
            return (
                <DashboardTemplate title="Assemblies" onSyncDatabase={this.loadData}>
                    <div className="main-dashboard-root">
                        <CircularProgress />
                    </div>
                </DashboardTemplate>
            );
        }

        let discountStrategyOptions = [];
        this.state.discountStrategies.forEach((discountStrategy) => {
            discountStrategyOptions.push({title: discountStrategy.name, value: discountStrategy.id});
        });

        let assemblyFamilyOptions = [];
        assemblyFamilyOptions.push({title: 'New...', value: 'New'});
        this.state.assemblyFamilies.forEach((assemblyFamily) => {
            assemblyFamilyOptions.push({title: assemblyFamily.assemblyFamilyId, value: assemblyFamily.id});
        });

        let assemblyTypeOptions = [];
        let manufacturerForOptions = [];
        let tertiaryTypeOptions = [];
        let brandOptions = [];
        
        // Collect options from assemblies
        this.state.assemblies.filter(x => x.assembly.isActive).forEach((assembly) => {
            if (assembly.assembly.assemblyType !== '' && !assemblyTypeOptions.includes(assembly.assembly.assemblyType))
                assemblyTypeOptions.push(assembly.assembly.assemblyType);
            if (assembly.assembly.manufacturerFor !== '' && !manufacturerForOptions.find(x => x.subType === assembly.assembly.manufacturerFor && x.assemblyType === assembly.assembly.assemblyType))
                manufacturerForOptions.push({subType: assembly.assembly.manufacturerFor, assemblyType: assembly.assembly.assemblyType});
            if (assembly.assembly.tertiaryType && assembly.assembly.tertiaryType !== '' && !tertiaryTypeOptions.includes(assembly.assembly.tertiaryType))
                tertiaryTypeOptions.push(assembly.assembly.tertiaryType);
            if (assembly.assembly.brand && assembly.assembly.brand !== '' && !brandOptions.includes(assembly.assembly.brand))
                brandOptions.push(assembly.assembly.brand);
        });
        
        // Collect options from sub-assemblies
        this.state.subAssemblies.filter(x => x.subAssembly.isActive).forEach((subAssembly) => {
            if (subAssembly.subAssembly.assemblyType !== '' && !assemblyTypeOptions.includes(subAssembly.subAssembly.assemblyType))
                assemblyTypeOptions.push(subAssembly.subAssembly.assemblyType);
            if (subAssembly.subAssembly.manufacturerFor !== '' && !manufacturerForOptions.find(x => x.subType === subAssembly.subAssembly.manufacturerFor && x.assemblyType === subAssembly.subAssembly.assemblyType))
                manufacturerForOptions.push({subType: subAssembly.subAssembly.manufacturerFor, assemblyType: subAssembly.subAssembly.assemblyType});
            if (subAssembly.subAssembly.tertiaryType && subAssembly.subAssembly.tertiaryType !== '' && !tertiaryTypeOptions.includes(subAssembly.subAssembly.tertiaryType))
                tertiaryTypeOptions.push(subAssembly.subAssembly.tertiaryType);
            if (subAssembly.subAssembly.brand && subAssembly.subAssembly.brand !== '' && !brandOptions.includes(subAssembly.subAssembly.brand))
                brandOptions.push(subAssembly.subAssembly.brand);
        });
        
        assemblyTypeOptions = assemblyTypeOptions.sort();
        manufacturerForOptions = manufacturerForOptions.sort((a, b) => a.subType > b.subType ? 1 : -1);
        tertiaryTypeOptions = tertiaryTypeOptions.sort();
        brandOptions = brandOptions.sort();

        // Filter options based on current selections
        const filteredManufacturerForOptions = this.state.selectedAssemblyType ? 
            manufacturerForOptions.filter(x => x.assemblyType === this.state.selectedAssemblyType) : 
            [];
        
        const filteredTertiaryTypeOptions = this.state.selectedAssemblyType && this.state.selectedManufacturerFor ?
            tertiaryTypeOptions.filter(tertiaryType => {
                // Check both assemblies and sub-assemblies
                const foundInAssemblies = this.state.assemblies.some(assembly => 
                    assembly.assembly.assemblyType === this.state.selectedAssemblyType &&
                    assembly.assembly.manufacturerFor === this.state.selectedManufacturerFor &&
                    assembly.assembly.tertiaryType === tertiaryType
                );
                const foundInSubAssemblies = this.state.subAssemblies.some(subAssembly => 
                    subAssembly.subAssembly.assemblyType === this.state.selectedAssemblyType &&
                    subAssembly.subAssembly.manufacturerFor === this.state.selectedManufacturerFor &&
                    subAssembly.subAssembly.tertiaryType === tertiaryType
                );
                return foundInAssemblies || foundInSubAssemblies;
            }) : 
            [];

        let subAssemblyTypeOptions = [];
        let subManufacturerForOptions = [];
        this.state.subAssemblies.forEach((assembly) => {
            if (assembly.subAssembly.assemblyType !== '' && !subAssemblyTypeOptions.includes(assembly.subAssembly.assemblyType))
                subAssemblyTypeOptions.push(assembly.subAssembly.assemblyType);
            if (assembly.subAssembly.manufacturerFor !== '' && !subManufacturerForOptions.find(x => x.subType === assembly.subAssembly.manufacturerFor && x.assemblyType === assembly.subAssembly.assemblyType))
                subManufacturerForOptions.push({subType: assembly.subAssembly.manufacturerFor, assemblyType: assembly.subAssembly.assemblyType});
        });
        subAssemblyTypeOptions = subAssemblyTypeOptions.sort();
        subManufacturerForOptions = subManufacturerForOptions.sort((a, b) => a.subType > b.subType ? 1 : -1);
        
        let lastAssemblyType = '';
        let lastManufacturerFor = '';
        let lastTertiaryType = null;
        let lastBrand = '';
        let partTypeHeader = [];
        let manufacturerForHeader = [];
        let tertiaryTypeHeader = [];

        const filteredAssembliesAndSubAssemblies = this.state.assembliesAndSubAssemblies.filter(x => {
            const assembly = x.assembly || x.subAssembly;
            const isAssembly = !!x.assembly;
            
            const isActiveFilter = (assembly && assembly.isActive === true) || this.state.showDeactivated;
            const assemblyTypeFilter = !this.state.selectedAssemblyType || assembly.assemblyType === this.state.selectedAssemblyType;
            const manufacturerForFilter = !this.state.selectedManufacturerFor || assembly.manufacturerFor === this.state.selectedManufacturerFor;
            const tertiaryTypeFilter = !this.state.selectedTertiaryType || assembly.tertiaryType === this.state.selectedTertiaryType;
            const brandFilter = !this.state.selectedBrand || assembly.brand === this.state.selectedBrand;
            
            // Check if currently packaging or currently shipping
            const isCurrentlyPackaging = assembly.currentlyPackaging === true;
            const isCurrentlyShipping = isAssembly && !assembly.finalOrderNumber; // Assemblies without finalOrderNumber are currently shipping
            const isCurrentRevision = isCurrentlyPackaging || isCurrentlyShipping;
            
            // Include old revisions only if showOldRevs is true
            const revisionFilter = this.state.showOldRevs || isCurrentRevision;
            
            // Apply search filter
            let searchFilter = true;
            if (this.state.searchTerm) {
                const searchTerms = this.state.searchTerm.split(' ').filter(term => term.trim() !== '');
                if (searchTerms.length > 0) {
                    searchFilter = searchTerms.every(term => {
                        const searchTerm = term.toLowerCase();
                        
                        // Search in assembly/subassembly ID
                        const idMatch = (assembly.assemblyId && assembly.assemblyId.toLowerCase().includes(searchTerm)) ||
                                       (assembly.subAssemblyId && assembly.subAssemblyId.toLowerCase().includes(searchTerm));
                        
                        // Search in description
                        const descriptionMatch = assembly.description && assembly.description.toLowerCase().includes(searchTerm);
                        
                        // Search in categories (primary/secondary/tertiary)
                        const categoryMatch = (assembly.assemblyType && assembly.assemblyType.toLowerCase().includes(searchTerm)) ||
                                            (assembly.manufacturerFor && assembly.manufacturerFor.toLowerCase().includes(searchTerm)) ||
                                            (assembly.tertiaryType && assembly.tertiaryType.toLowerCase().includes(searchTerm));
                        
                        // Search in spare parts sets (for assemblies)
                        let sparePartsMatch = false;
                        if (isAssembly && assembly.spareBushingsSetId) {
                            const spareBushingsSet = this.state.assemblies.find(a => a.assembly.id === assembly.spareBushingsSetId);
                            if (spareBushingsSet && spareBushingsSet.assembly.assemblyId.toLowerCase().includes(searchTerm)) {
                                sparePartsMatch = true;
                            }
                        }
                        if (isAssembly && assembly.spareHardwareSetId) {
                            const spareHardwareSet = this.state.assemblies.find(a => a.assembly.id === assembly.spareHardwareSetId);
                            if (spareHardwareSet && spareHardwareSet.assembly.assemblyId.toLowerCase().includes(searchTerm)) {
                                sparePartsMatch = true;
                            }
                        }
                        
                        return idMatch || descriptionMatch || categoryMatch || sparePartsMatch;
                    });
                }
            }
            
            return isActiveFilter && assemblyTypeFilter && manufacturerForFilter && tertiaryTypeFilter && brandFilter && revisionFilter && searchFilter;
        });

        const useFlatSort = !usesCatalogCategoryHeaders(this.state.sortField);
        const displayAssemblies = applyCatalogDisplaySort(filteredAssembliesAndSubAssemblies, this.state.sortField, this.state.sortDirection, {
            kind: 'assemblyCatalog',
        });

        return (
            <DashboardTemplate title="Assemblies" onSyncDatabase={this.loadData}>
                <div className="main-dashboard-root">
                    <div className="container">
                        <div className={`${classes.toolbar} toolbar-responsive`}>
                            <div className={`${classes.toolbarLeft} toolbar-left`} style={{ display: 'flex', alignItems: 'center', gap: '16px', flex: 1, maxWidth: '60%' }}>
                                <TextField
                                    value={this.state.searchTerm}
                                    onChange={this.searchAssembly}
                                    label="Search Assemblies..."
                                    variant="outlined"
                                    className="search-field"
                                    style={{minWidth: '300px'}}
                                    inputRef={ref => this.searchInputRef = ref}
                                />
                                <Autocomplete autoHighlight
                                    id="ddlAssemblyType"
                                    style={{ minWidth: 250 }}
                                    options={assemblyTypeOptions}
                                    onChange={this.handleAssemblyTypeFilterChange}
                                    value={this.state.selectedAssemblyType}
                                    inputValue={this.state.selectedAssemblyType}
                                    className="autocomplete-dropdown"
                                    renderInput={(params) => <TextField {...params} inputProps={{
                                        ...params.inputProps
                                    }} label="Assembly Category (Primary)" autoComplete="new-password" variant="outlined"/>}
                                />
                                <Autocomplete autoHighlight
                                    id="ddlManufacturerFor"
                                    style={{ minWidth: 250 }}
                                    options={filteredManufacturerForOptions}
                                    onChange={this.handleManufacturerForFilterChange}
                                    value={this.state.selectedManufacturerFor}
                                    inputValue={this.state.selectedManufacturerFor}
                                    getOptionLabel={(option) => option.subType}
                                    getOptionSelected={(option) => option.subType === this.state.selectedManufacturerFor}
                                    disabled={!this.state.selectedAssemblyType}
                                    className="autocomplete-dropdown"
                                    renderInput={(params) => <TextField {...params} inputProps={{
                                        ...params.inputProps
                                    }} label="Assembly Category (Secondary)" autoComplete="new-password" variant="outlined"/>}
                                />
                                <Autocomplete autoHighlight
                                    id="ddlTertiaryType"
                                    style={{ minWidth: 250 }}
                                    options={filteredTertiaryTypeOptions}
                                    onChange={this.handleTertiaryTypeFilterChange}
                                    value={this.state.selectedTertiaryType}
                                    inputValue={this.state.selectedTertiaryType}
                                    disabled={!this.state.selectedManufacturerFor}
                                    className="autocomplete-dropdown"
                                    renderInput={(params) => <TextField {...params} inputProps={{
                                        ...params.inputProps
                                    }} label="Assembly Category (Tertiary)" autoComplete="new-password" variant="outlined"/>}
                                />
                                <Autocomplete autoHighlight
                                    id="ddlBrand"
                                    style={{ minWidth: 250 }}
                                    options={brandOptions}
                                    onChange={this.handleBrandFilterChange}
                                    value={this.state.selectedBrand}
                                    inputValue={this.state.selectedBrand}
                                    className="autocomplete-dropdown"
                                    renderInput={(params) => <TextField {...params} inputProps={{
                                        ...params.inputProps
                                    }} label="Brand" autoComplete="new-password" variant="outlined"/>}
                                />
                            </div>
                            <div className={`${classes.toolbarRight} toolbar-right`}>
                                <div className={classes.filterToggle} onClick={this.toggleAdvancedInfo}>
                                    <Checkbox
                                        checked={this.state.showAdvancedInfo}
                                        onChange={this.toggleAdvancedInfo}
                                    />
                                    <span className={classes.filterLabel}>Show Advanced Stats</span>
                                </div>
                                <div className={classes.filterToggle} onClick={this.toggleSpareParts}>
                                    <Checkbox
                                        checked={this.state.showSpareParts}
                                        onChange={this.toggleSpareParts}
                                    />
                                    <span className={classes.filterLabel}>Show Spare Parts</span>
                                </div>
                                <div className={classes.filterToggle} onClick={this.toggleOldRevs}>
                                    <Checkbox
                                        checked={this.state.showOldRevs}
                                        onChange={this.toggleOldRevs}
                                    />
                                    <span className={classes.filterLabel}>Show Old Revisions</span>
                                </div>
                                <div className={classes.filterToggle} onClick={this.toggleDeactivated}>
                                    <Checkbox
                                        checked={this.state.showDeactivated}
                                        onChange={this.toggleDeactivated}
                                    />
                                    <span className={classes.filterLabel}>Show Deactivated</span>
                                </div>
                                {this.state.permissions.includes('EditAssembliesAndParts') && (
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={this.openAssemblyMenu}
                                        className="success-button-lg action-button"
                                        style={{minWidth: 100}}
                                    >
                                        New assembly
                                    </Button>
                                )}
                            </div>
                        </div>
                        
                        <center>
                            <TablePagination
                                rowsPerPageOptions={[50, 100, 200, 500]}
                                colSpan={50}
                                count={displayAssemblies.length}
                                rowsPerPage={this.state.rowsPerPage}
                                page={this.state.page}
                                slotProps={{
                                    select: {
                                        'aria-label': 'rows per page',
                                    },
                                    actions: {
                                        showFirstButton: true,
                                        showLastButton: true,
                                        slots: {
                                            firstPageIcon: FirstPageIcon,
                                            lastPageIcon: LastPageIcon,
                                            nextPageIcon: ChevronRightIcon,
                                            backPageIcon: ChevronLeftIcon,
                                        },
                                    },
                                }}
                                onChangePage={this.handleChangePage}
                                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                            />
                        </center>
                        <div className="parts-table-container">
                            <table className="parts-table">
                                <thead>
                                <tr>
                                    <th style={{minWidth: 40}}>Select</th>
                                    <SortableTableHeader field="partNumber" sortField={this.state.sortField} sortDirection={this.state.sortDirection} onSort={this.handleSort} style={{minWidth: window.innerWidth > 2200 ? 350 : 300}}>PN + Description</SortableTableHeader>
                                    <th style={{minWidth: 40}}>
                                        <Tooltip
                                            title="Currently Packaging - Only one revision per assembly/subassembly can be packaging at a time"
                                            placement="top" TransitionComponent={Zoom}>
                                            <span>📦</span>
                                        </Tooltip>
                                    </th>
                                    <th style={{minWidth: 40}}>
                                        <Tooltip
                                            title="Currently Selling - When multiple assembly revisions with the same assemblyId don't have a finalOrderNumber, the lowest revision is currently selling"
                                            placement="top" TransitionComponent={Zoom}>
                                            <span>🛒</span>
                                        </Tooltip>
                                    </th>
                                    <th style={{minWidth: 20}}>FG</th>
                                    <SortableTableHeader field="shippingCost" sortField={this.state.sortField} sortDirection={this.state.sortDirection} onSort={this.handleSort} style={{minWidth: 70}}>Shipping<br />Cost</SortableTableHeader>
                                    <SortableTableHeader field="msrp" sortField={this.state.sortField} sortDirection={this.state.sortDirection} onSort={this.handleSort} style={{minWidth: 60}}>MSRP</SortableTableHeader>
                                    {!this.state.showAdvancedInfo ?
                                        <React.Fragment>
                                            <th style={{minWidth: 80}}>Discount<br />Tier 1</th>
                                            <th style={{minWidth: 70}}>Price Tier 1</th>
                                            <th style={{minWidth: 70}}>Discount<br/>Tier 2</th>
                                            <th style={{minWidth: 80}}>Price Tier 2</th>
                                            <th style={{minWidth: 70}}>Discount<br />Tier 3</th>
                                            <th style={{minWidth: 80}}>Price Tier 3</th>
                                        </React.Fragment>
                                        : ""}
                                    {this.state.showSpareParts ?
                                        <React.Fragment>
                                            <th style={{minWidth: 90}}>Spare<br/>Bushings Set</th>
                                            <th style={{minWidth: 90}}>Spare<br/>Bushings Qty</th>
                                            <th style={{minWidth: 90}}>Spare<br/>Hardware Set</th>
                                            <th style={{minWidth: 90}}>Spare<br/>Hardware Qty</th>
                                        </React.Fragment>
                                        : ""}
                                    {this.state.showAdvancedInfo ?
                                        <th style={{minWidth: 60, border: '1px solid #fe65ff'}}>
                                            <Tooltip
                                                title="Total number of times this assembly has been sold in a finished good."
                                                placement="top" TransitionComponent={Zoom}>
                                                <span>Total<br/>Sold</span>
                                            </Tooltip>
                                        </th>
                                        : ""}
                                    <th style={{minWidth: 65, border: '1px solid #fe65ff'}}>
                                        <Tooltip
                                            title="Total number of times this assembly has been sold in a finished good."
                                            placement="top" TransitionComponent={Zoom}>
                                            <span>Total Sold<br />w/ Rev</span>
                                        </Tooltip>
                                    </th>
                                    {this.state.showAdvancedInfo ?
                                        <th style={{minWidth: 70, border: '1px solid #fe65ff'}}>
                                            <Tooltip
                                                title="Total number of times this assembly has been packaged. For finished goods, that would be total number made. For subassemblies, that would include those packaged that have not been put into a finished good and those that are currently sitting in finished goods."
                                                placement="top" TransitionComponent={Zoom}>
                                                <span>Total<br/>Ass'd</span>
                                            </Tooltip>
                                        </th>
                                        : ""}
                                    <th style={{minWidth: 70, border: '1px solid #fe65ff'}}>
                                        <Tooltip
                                            title="Total number of times this assembly has been packaged. For finished goods, that would be total number made. For subassemblies, that would include those packaged that have not been put into a finished good and those that are currently sitting in finished goods."
                                            placement="top" TransitionComponent={Zoom}>
                                            <span>Total Ass'd<br/>w/ Rev</span>
                                        </Tooltip>
                                    </th>
                                    {this.state.showAdvancedInfo ?
                                        <th style={{minWidth: 70, border: '1px solid #fe65ff'}}>
                                            <Tooltip
                                                title="For finished goods, this is how many are packaged and sitting on the shelf ready to be sold. For subassemblies, this is how many are packaged sitting on the shelf waiting to be put into a finished good."
                                                placement="top" TransitionComponent={Zoom}>
                                                <span>Total Ass'd<br/>On Hand</span>
                                            </Tooltip>
                                        </th>
                                        : ""}
                                    <th style={{minWidth: 90, border: '1px solid #fe65ff'}}>
                                        <Tooltip
                                            title="For finished goods, this is how many are packaged and sitting on the shelf ready to be sold. For subassemblies, this is how many are packaged sitting on the shelf waiting to be put into a finished good."
                                            placement="top" TransitionComponent={Zoom}>
                                            <span>Total Ass'd On<br/>Hand w/ Rev</span>
                                        </Tooltip>
                                    </th>
                                    <th style={{minWidth: 100, border: '1px solid #fe65ff'}}>
                                        <Tooltip
                                            title="Total number of the subassembly that is currently sitting in an unsold finished good."
                                            placement="top" TransitionComponent={Zoom}>
                                            <span>SubA Total On<br/>Hand in FG</span>
                                        </Tooltip>
                                    </th>
                                    {this.state.showAdvancedInfo ?
                                        <th style={{minWidth: 120, border: '1px solid #fe65ff'}}>
                                            <Tooltip
                                                title="Total number of the subassembly that is currently sitting in an unsold finished good."
                                                placement="top" TransitionComponent={Zoom}>
                                                <span>SubA Total On<br/>Hand in FG w/ Rev</span>
                                            </Tooltip>
                                        </th>
                                    : ""}
                                    {this.state.showAdvancedInfo ?
                                        <th style={{minWidth: 80}}>4 week<br/>Sales / wk</th>
                                        : ""}
                                    <th style={{minWidth: 115}}>4 week<br/>Sales / wk w/ Rev</th>
                                    {this.state.showAdvancedInfo ?
                                        <th style={{minWidth: 80}}>24 week<br/>Sales / wk</th>
                                        : ""}
                                    <th style={{minWidth: 115}}>24 week<br/>Sales / wk w/ Rev</th>
                                    {this.state.showAdvancedInfo ?
                                        <React.Fragment>
                                            <th style={{minWidth: 70}}>Avg<br/>Sales / wk</th>
                                            <th style={{minWidth: 100}}>Avg Sales / wk<br/>w/ Rev</th>
                                        </React.Fragment>
                                        : ""}
                                </tr>
                                </thead>
                                <tbody>
                                {displayAssemblies.slice(this.state.page * this.state.rowsPerPage, this.state.page * this.state.rowsPerPage + this.state.rowsPerPage).map((assemblyExpanded) => {
                                    const assembly = assemblyExpanded.assembly || assemblyExpanded.subAssembly;
                                    if (!assembly) return '';
                                    
                                    const isAssembly = !!assemblyExpanded.assembly;

                                    if (!useFlatSort && assembly.assemblyType !== lastAssemblyType) {
                                        const currentAssemblyType = assembly.assemblyType; // Capture the current value
                                        partTypeHeader = [<tr key={`type-${assembly.assemblyType}`} className="part-type-header">
                                            <td colSpan={19 + (this.state.showSpareParts ? 4 : 0) + (this.state.showAdvancedInfo ? 8 : 0)} style={{
                                                backgroundColor: '#000',
                                                color: '#FFF',
                                                fontWeight: 'bold',
                                                padding: '2px 4px !important',
                                                borderBottom: '2px solid #fff',
                                                cursor: 'pointer'
                                            }} className='text-left'
                                            onClick={() => this.handleAssemblyTypeHeaderClick(currentAssemblyType)}
                                            title="Click to edit category">{assembly.assemblyType}</td>
                                        </tr>];
                                        lastAssemblyType = assembly.assemblyType;
                                    } else {
                                        partTypeHeader = [];
                                    }

                                    if (!useFlatSort && assembly.manufacturerFor !== lastManufacturerFor) {
                                        const currentManufacturerFor = assembly.manufacturerFor; // Capture the current value
                                        manufacturerForHeader = [<tr key={`manufacturer-${assembly.manufacturerFor}`} className="manufacturer-header">
                                            <td colSpan={19 + (this.state.showSpareParts ? 4 : 0) + (this.state.showAdvancedInfo ? 8 : 0)} style={{
                                                backgroundColor: '#767676',
                                                color: '#FFF',
                                                fontWeight: 'bold',
                                                padding: '2px 4px !important',
                                                cursor: 'pointer'
                                            }} className='text-left'
                                            onClick={() => this.handleManufacturerForHeaderClick(currentManufacturerFor)}
                                            title="Click to edit category">{assembly.manufacturerFor || '\u00A0'}</td>
                                        </tr>];
                                        lastManufacturerFor = assembly.manufacturerFor;
                                    } else {
                                        manufacturerForHeader = [];
                                    }

                                    if (!useFlatSort && assembly.tertiaryType !== lastTertiaryType) {
                                        // Show header if there's actually a tertiary type
                                        if (assembly.tertiaryType && assembly.tertiaryType.trim() !== '') {
                                            const currentTertiaryType = assembly.tertiaryType; // Capture the current value
                                            tertiaryTypeHeader = [<tr key={`tertiary-${assembly.tertiaryType}`} className="tertiary-type-header">
                                                <td colSpan={19 + (this.state.showSpareParts ? 4 : 0) + (this.state.showAdvancedInfo ? 8 : 0)} style={{
                                                    backgroundColor: '#767676',
                                                    color: '#000',
                                                    fontWeight: 'bold',
                                                    padding: '2px 4px !important',
                                                    borderBottom: '1px solid #ccc',
                                                    cursor: 'pointer'
                                                }} className='text-left'
                                                onClick={() => this.handleTertiaryTypeHeaderClick(currentTertiaryType)}
                                                title="Click to edit category">
                                                    {assembly.tertiaryType}
                                                </td>
                                            </tr>];
                                        } else if (lastTertiaryType && lastTertiaryType.trim() !== '') {
                                            // Add an empty/clearing header when transitioning from tertiary type back to no tertiary type
                                            tertiaryTypeHeader = [<tr key={`tertiary-clear`} className="tertiary-type-header">
                                                <td colSpan={19 + (this.state.showSpareParts ? 4 : 0) + (this.state.showAdvancedInfo ? 8 : 0)} style={{
                                                    backgroundColor: 'transparent',
                                                    height: '1px',
                                                    padding: '0',
                                                    borderBottom: 'none'
                                                }} className='text-left'>
                                                    &nbsp;
                                                </td>
                                            </tr>];
                                        } else {
                                            tertiaryTypeHeader = [];
                                        }
                                        lastTertiaryType = assembly.tertiaryType;
                                    } else {
                                        tertiaryTypeHeader = [];
                                    }

                                    let brandHeader = [];
                                    if (assembly.brand !== lastBrand) {
                                        // Show header if there's actually a brand
                                        if (assembly.brand && assembly.brand.trim() !== '') {
                                            const currentBrand = assembly.brand;
                                            brandHeader = [<tr key={`brand-${assembly.brand}`} className="brand-header">
                                                <td colSpan={19 + (this.state.showSpareParts ? 4 : 0) + (this.state.showAdvancedInfo ? 8 : 0)} style={{
                                                    backgroundColor: '#d0e8f2',
                                                    color: '#333',
                                                    fontWeight: 'bold',
                                                    padding: '2px 4px !important',
                                                    borderBottom: '1px solid #ccc'
                                                }} className='text-left'
                                                title="Brand">
                                                    Brand: {assembly.brand}
                                                </td>
                                            </tr>];
                                        } else if (lastBrand && lastBrand.trim() !== '') {
                                            // Add an empty/clearing header when transitioning from brand back to no brand
                                            brandHeader = [<tr key={`brand-clear`} className="brand-header">
                                                <td colSpan={19 + (this.state.showSpareParts ? 4 : 0) + (this.state.showAdvancedInfo ? 8 : 0)} style={{
                                                    backgroundColor: 'transparent',
                                                    height: '1px',
                                                    padding: '0',
                                                    borderBottom: 'none'
                                                }} className='text-left'>
                                                    &nbsp;
                                                </td>
                                            </tr>];
                                        } else {
                                            brandHeader = [];
                                        }
                                        lastBrand = assembly.brand;
                                    } else {
                                        brandHeader = [];
                                    }

                                    let spareBushingsSet;
                                    if (assembly.spareBushingsSetId && assembly.spareBushingsSetId !== '') spareBushingsSet = self.state.assemblies.find(x => x.assembly.id === assembly.spareBushingsSetId);
                                    let spareHardwareSet;
                                    if (assembly.spareHardwareSetId && assembly.spareHardwareSetId !== '') spareHardwareSet = self.state.assemblies.find(x => x.assembly.id === assembly.spareHardwareSetId);

                                    return (
                                        <React.Fragment>
                                            {partTypeHeader}
                                            {manufacturerForHeader}
                                            {tertiaryTypeHeader}
                                            {brandHeader}
                                            <tr style={this.state.permissions.includes('EditAssembliesAndParts') ? {
                                                cursor: 'pointer',
                                                opacity: assembly.isActive ? 1 : 0.6
                                            } : {}}
                                                onClick={(event) => this.handleRowClick(event, assemblyExpanded)}>
                                                <td 
                                                    style={{textAlign: 'center', paddingTop: 4, cursor: 'pointer'}}
                                                    onClick={(e) => {
                                                        const isCtrlPressed = e.ctrlKey || e.metaKey;
                                                        const isShiftPressed = e.shiftKey;
                                                        
                                                        if (isCtrlPressed || isShiftPressed) {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            if (e.nativeEvent && e.nativeEvent.stopImmediatePropagation) {
                                                                e.nativeEvent.stopImmediatePropagation();
                                                            }
                                                            const syntheticEvent = {
                                                                ctrlKey: isCtrlPressed,
                                                                metaKey: e.metaKey,
                                                                shiftKey: isShiftPressed,
                                                                preventDefault: () => {},
                                                                stopPropagation: () => {},
                                                                target: { checked: !this.state.selectedAssemblies[assembly.id] },
                                                                nativeEvent: e.nativeEvent
                                                            };
                                                            this.handleAssemblySelection(assembly.id, syntheticEvent);
                                                        }
                                                    }}
                                                    onMouseDown={(e) => {
                                                        const isCtrlPressed = e.ctrlKey || e.metaKey;
                                                        const isShiftPressed = e.shiftKey;
                                                        
                                                        if (isCtrlPressed || isShiftPressed) {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            if (e.nativeEvent && e.nativeEvent.stopImmediatePropagation) {
                                                                e.nativeEvent.stopImmediatePropagation();
                                                            }
                                                        }
                                                    }}
                                                >
                                                    <span
                                                        onClick={(e) => {
                                                            const isCtrlPressed = e.ctrlKey || e.metaKey;
                                                            const isShiftPressed = e.shiftKey;
                                                            
                                                            if (isCtrlPressed || isShiftPressed) {
                                                                e.preventDefault();
                                                                e.stopPropagation();
                                                                if (e.nativeEvent && e.nativeEvent.stopImmediatePropagation) {
                                                                    e.nativeEvent.stopImmediatePropagation();
                                                                }
                                                            }
                                                        }}
                                                        style={{display: 'inline-block'}}
                                                    >
                                                        <Checkbox
                                                            checked={!!this.state.selectedAssemblies[assembly.id]}
                                                            onChange={(event) => {
                                                                if (this.state.isProcessingModifierClick) {
                                                                    event.preventDefault();
                                                                    event.stopPropagation();
                                                                    return;
                                                                }
                                                                
                                                                const isCtrlPressed = event.ctrlKey || event.metaKey;
                                                                const isShiftPressed = event.shiftKey;
                                                                
                                                                if (isCtrlPressed || isShiftPressed) {
                                                                    event.preventDefault();
                                                                    event.stopPropagation();
                                                                    return;
                                                                }
                                                                
                                                                event.stopPropagation();
                                                                this.handleAssemblySelection(assembly.id, event);
                                                            }}
                                                            onClick={(e) => {
                                                                const isCtrlPressed = e.ctrlKey || e.metaKey;
                                                                const isShiftPressed = e.shiftKey;
                                                                
                                                                if (isCtrlPressed || isShiftPressed) {
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                    if (e.nativeEvent && e.nativeEvent.stopImmediatePropagation) {
                                                                        e.nativeEvent.stopImmediatePropagation();
                                                                    }
                                                                    return false;
                                                                }
                                                            }}
                                                            style={{padding: '0 0 2px'}}
                                                        />
                                                    </span>
                                                </td>
                                                <td className="text-left" onClick={(event) => this.state.permissions.includes('EditAssembliesAndParts') ? this.editAssembly(assemblyExpanded, event.ctrlKey) : null}>
                                                    <PartDisplay 
                                                        part={{
                                                            partId: isAssembly ? assembly.assemblyId : assembly.subAssemblyId,
                                                            revision: assembly.revision,
                                                            description: assembly.description
                                                        }}
                                                        variant="table"
                                                        classes={this.props.classes}
                                                        onClick={this.state.permissions.includes('EditAssembliesAndParts') ? 
                                                            (event) => this.editAssembly(assemblyExpanded, event.ctrlKey) : null
                                                        }
                                                    />
                                                </td>
                                                <td>{assembly.currentlyPackaging ? '📦' : ''}</td>
                                                <td>{isAssembly && this.isAssemblyCurrentlySelling(assembly) ? '🛒' : ''}</td>
                                                <td>{isAssembly ? 'x' : ''}</td>
                                                <td>{isAssembly ? `$${assembly.shippingCost.toFixed(2)}` : ''}</td>
                                                <td>{isAssembly ? `$${assembly.msrp.toFixed(2)}` : ''}</td>
                                                {!this.state.showAdvancedInfo ?
                                                    <React.Fragment>
                                                        <td style={{backgroundColor: '#ddd'}}>{isAssembly ? `${assembly.discountTier1 * 100}%` : ''}</td>
                                                        <td style={{backgroundColor: '#ddd'}}>{isAssembly ? `$${(assembly.msrp * (1 - assembly.discountTier1)).toFixed(2)}` : ''}</td>
                                                        <td>{isAssembly ? `${assembly.discountTier2 * 100}%` : ''}</td>
                                                        <td>{isAssembly ? `$${(assembly.msrp * (1 - assembly.discountTier2)).toFixed(2)}` : ''}</td>
                                                        <td style={{backgroundColor: '#ddd'}}>{isAssembly ? `${assembly.discountTier3 * 100}%` : ''}</td>
                                                        <td style={{backgroundColor: '#ddd'}}>{isAssembly ? `$${(assembly.msrp * (1 - assembly.discountTier3)).toFixed(2)}` : ''}</td>
                                                    </React.Fragment>
                                                    : ""}
                                                {this.state.showSpareParts ?
                                                    <React.Fragment>
                                                        <td>
                                                            {isAssembly && this.state.permissions.includes('EditAssembliesAndParts') ?
                                                                <span>
                                                                    {spareBushingsSet ?
                                                                        <span style={{fontWeight: 'bold', color: 'black', cursor: 'pointer'}}
                                                                              onClick={(event) => this.editAssembly(spareBushingsSet, event.ctrlKey)}>{spareBushingsSet.assembly.assemblyId}</span>
                                                                        : ''}
                                                                </span>
                                                                :
                                                                ''
                                                            }
                                                        </td>
                                                        <td>{isAssembly ? assembly.spareBushingsSetQuantity : ''}</td>
                                                        <td>
                                                            {isAssembly && this.state.permissions.includes('EditAssembliesAndParts') ?
                                                                <span>
                                                                    {spareHardwareSet ?
                                                                        <span style={{fontWeight: 'bold', color: 'black', cursor: 'pointer'}}
                                                                              onClick={(event) => this.editAssembly(spareHardwareSet, event.ctrlKey)}>{spareHardwareSet.assembly.assemblyId}</span>
                                                                        : ''}
                                                                </span>
                                                                :
                                                                ''
                                                            }
                                                        </td>
                                                        <td>{isAssembly ? assembly.spareHardwareSetQuantity : ''}</td>
                                                    </React.Fragment>
                                                    : ""}
                                                {this.state.showAdvancedInfo ?
                                                    <td>{assemblyExpanded.totalSold ? assemblyExpanded.totalSold.toFixed(0) : '0'}</td>
                                                    : ""}
                                                <td>{assemblyExpanded.totalSoldWithRev ? assemblyExpanded.totalSoldWithRev.toFixed(0) : '0'}</td>
                                                {this.state.showAdvancedInfo ?
                                                    <td>{assemblyExpanded.totalAssembled ? assemblyExpanded.totalAssembled.toFixed(0) : '0'}</td>
                                                    : ""}
                                                <td>{assemblyExpanded.totalAssembledWithRev ? assemblyExpanded.totalAssembledWithRev.toFixed(0) : '0'}</td>
                                                {this.state.showAdvancedInfo ?
                                                    <td>{assemblyExpanded.totalAssembledOnHand ? assemblyExpanded.totalAssembledOnHand.toFixed(0) : '0'}</td>
                                                    : ""}
                                                <td>{assemblyExpanded.totalAssembledOnHandWithRev ? assemblyExpanded.totalAssembledOnHandWithRev.toFixed(0) : '0'}</td>
                                                <td>{!isAssembly && assemblyExpanded.subATotalOnHandFG ? assemblyExpanded.subATotalOnHandFG.toFixed(0) : ''}</td>
                                                {this.state.showAdvancedInfo ?
                                                    <td>{!isAssembly && assemblyExpanded.subATotalOnHandFGWithRev ? assemblyExpanded.subATotalOnHandFGWithRev.toFixed(0) : ''}</td>
                                                : ""}
                                                {this.state.showAdvancedInfo ?
                                                    <td>{assemblyExpanded.fourWeekSalesPerWeek ? assemblyExpanded.fourWeekSalesPerWeek.toFixed(2) : '0.00'}</td>
                                                    : ""}
                                                <td>{assemblyExpanded.fourWeekSalesPerWeekWithRev ? assemblyExpanded.fourWeekSalesPerWeekWithRev.toFixed(2) : '0.00'}</td>
                                                {this.state.showAdvancedInfo ?
                                                    <td>{assemblyExpanded.twentyFourWeekSalesPerWeek ? assemblyExpanded.twentyFourWeekSalesPerWeek.toFixed(2) : '0.00'}</td>
                                                    : ""}
                                                <td>{assemblyExpanded.twentyFourWeekSalesPerWeekWithRev ? assemblyExpanded.twentyFourWeekSalesPerWeekWithRev.toFixed(2) : '0.00'}</td>
                                                {this.state.showAdvancedInfo ?
                                                    <React.Fragment>
                                                        <td>{assemblyExpanded.averageSalesPerWeek ? assemblyExpanded.averageSalesPerWeek.toFixed(2) : '0.00'}</td>
                                                        <td>{assemblyExpanded.averageSalesPerWeekWithRev ? assemblyExpanded.averageSalesPerWeekWithRev.toFixed(2) : '0.00'}</td>
                                                    </React.Fragment>
                                                    : ""}
                                            </tr>
                                        </React.Fragment>
                                    )
                                })}
                                </tbody>
                            </table>
                            
                            {/* Floating action buttons for multiselect */}
                            {Object.keys(this.state.selectedAssemblies).length > 0 && (
                                <div style={{
                                    position: 'fixed',
                                    bottom: 20,
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                    zIndex: 1000,
                                    display: 'flex',
                                    gap: '16px'
                                }}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={this.deselectAllAssemblies}
                                        className="success-button-lg"
                                    >
                                        Deselect All
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={this.openAssignCategory}
                                        className="success-button-lg"
                                    >
                                        Assign Categories
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={() => this.setState({assignVehiclesOpen: true})}
                                        className="success-button-lg"
                                    >
                                        Assign Vehicles
                                    </Button>
                                </div>
                            )}

                            <BulkAssignVehiclesDrawer
                                open={this.state.assignVehiclesOpen}
                                onClose={() => this.setState({assignVehiclesOpen: false})}
                                products={this.getSelectedVehicleProducts()}
                            />

                            {/* Category assignment drawer */}
                            <DrawerMenuRight 
                                title="Assign Categories"
                                customWidth={600} 
                                open={this.state.assignCategoryOpen}
                                onClose={this.closeAssignCategory}
                                disableEnterKeySubmit
                                hasUnsavedChanges={
                                    this.state.primaryCategoryValue !== '' ||
                                    this.state.primaryCategoryNewValue !== '' ||
                                    this.state.secondaryCategoryValue !== '' ||
                                    this.state.secondaryCategoryNewValue !== '' ||
                                    this.state.tertiaryCategoryValue !== '' ||
                                    this.state.tertiaryCategoryNewValue !== '' ||
                                    this.state.brandValue !== '' ||
                                    this.state.brandNewValue !== ''
                                }
                            >
                                <div style={{padding: '20px'}}>
                                    {/* Primary Category */}
                                    <Autocomplete autoHighlight
                                        style={{marginBottom: 20}}
                                        options={this.getCategoryOptions('primary')}
                                        onChange={(event, newValue) => {
                                            if (newValue === 'New...') {
                                                this.setState({
                                                    primaryCategoryValue: 'New...',
                                                    primaryCategoryInputValue: 'New...',
                                                    showNewPrimaryCategoryField: true,
                                                    primaryCategoryNewValue: ''
                                                });
                                            } else {
                                                this.setState({
                                                    primaryCategoryValue: newValue || '',
                                                    primaryCategoryInputValue: newValue || '',
                                                    showNewPrimaryCategoryField: false,
                                                    primaryCategoryNewValue: ''
                                                });
                                            }
                                        }}
                                        onInputChange={(event, newInputValue) => {
                                            this.setState({
                                                primaryCategoryInputValue: newInputValue
                                            });
                                        }}
                                        value={this.state.primaryCategoryValue}
                                        inputValue={this.state.primaryCategoryInputValue}
                                        className="autocomplete-dropdown"
                                        renderInput={(params) => <TextField {...params} inputProps={{
                                            ...params.inputProps
                                        }} label="Assembly Category (Primary)" autoComplete="new-password" variant="outlined"/>}
                                    />
                                    {this.state.showNewPrimaryCategoryField && (
                                        <TextField
                                            value={this.state.primaryCategoryNewValue}
                                            onChange={(e) => this.setState({primaryCategoryNewValue: e.target.value})}
                                            label="New Assembly Category (Primary)"
                                            variant="outlined"
                                            style={{width: '100%', marginBottom: 20}}
                                            inputProps={{maxLength: 200}}
                                        />
                                    )}

                                    {/* Secondary Category */}
                                    <Autocomplete autoHighlight
                                        style={{marginBottom: 20}}
                                        options={this.getCategoryOptions('secondary')}
                                        onChange={(event, newValue) => {
                                            if (newValue === 'New...') {
                                                this.setState({
                                                    secondaryCategoryValue: 'New...',
                                                    secondaryCategoryInputValue: 'New...',
                                                    showNewSecondaryCategoryField: true,
                                                    secondaryCategoryNewValue: ''
                                                });
                                            } else {
                                                this.setState({
                                                    secondaryCategoryValue: newValue || '',
                                                    secondaryCategoryInputValue: newValue || '',
                                                    showNewSecondaryCategoryField: false,
                                                    secondaryCategoryNewValue: ''
                                                });
                                            }
                                        }}
                                        onInputChange={(event, newInputValue) => {
                                            this.setState({
                                                secondaryCategoryInputValue: newInputValue
                                            });
                                        }}
                                        value={this.state.secondaryCategoryValue}
                                        inputValue={this.state.secondaryCategoryInputValue}
                                        className="autocomplete-dropdown"
                                        renderInput={(params) => <TextField {...params} inputProps={{
                                            ...params.inputProps
                                        }} label="Assembly Category (Secondary)" autoComplete="new-password" variant="outlined"/>}
                                    />
                                    {this.state.showNewSecondaryCategoryField && (
                                        <TextField
                                            value={this.state.secondaryCategoryNewValue}
                                            onChange={(e) => this.setState({secondaryCategoryNewValue: e.target.value})}
                                            label="New Assembly Category (Secondary)"
                                            variant="outlined"
                                            style={{width: '100%', marginBottom: 20}}
                                            inputProps={{maxLength: 200}}
                                        />
                                    )}

                                    {/* Tertiary Category */}
                                    <Autocomplete autoHighlight
                                        style={{marginBottom: 20}}
                                        options={this.getCategoryOptions('tertiary')}
                                        onChange={(event, newValue) => {
                                            if (newValue === 'New...') {
                                                this.setState({
                                                    tertiaryCategoryValue: 'New...',
                                                    tertiaryCategoryInputValue: 'New...',
                                                    showNewTertiaryCategoryField: true,
                                                    tertiaryCategoryNewValue: ''
                                                });
                                            } else {
                                                this.setState({
                                                    tertiaryCategoryValue: newValue || '',
                                                    tertiaryCategoryInputValue: newValue || '',
                                                    showNewTertiaryCategoryField: false,
                                                    tertiaryCategoryNewValue: ''
                                                });
                                            }
                                        }}
                                        onInputChange={(event, newInputValue) => {
                                            this.setState({
                                                tertiaryCategoryInputValue: newInputValue
                                            });
                                        }}
                                        value={this.state.tertiaryCategoryValue}
                                        inputValue={this.state.tertiaryCategoryInputValue}
                                        className="autocomplete-dropdown"
                                        renderInput={(params) => <TextField {...params} inputProps={{
                                            ...params.inputProps
                                        }} label="Assembly Category (Tertiary)" autoComplete="new-password" variant="outlined"/>}
                                    />
                                    {this.state.showNewTertiaryCategoryField && (
                                        <TextField
                                            value={this.state.tertiaryCategoryNewValue}
                                            onChange={(e) => this.setState({tertiaryCategoryNewValue: e.target.value})}
                                            label="New Assembly Category (Tertiary)"
                                            variant="outlined"
                                            style={{width: '100%', marginBottom: 20}}
                                            inputProps={{maxLength: 200}}
                                        />
                                    )}

                                    {/* Brand */}
                                    <Autocomplete autoHighlight
                                        style={{marginBottom: 20}}
                                        options={this.getCategoryOptions('brand')}
                                        onChange={(event, newValue) => {
                                            if (newValue === 'New...') {
                                                this.setState({
                                                    brandValue: 'New...',
                                                    brandInputValue: 'New...',
                                                    showNewBrandField: true,
                                                    brandNewValue: ''
                                                });
                                            } else {
                                                this.setState({
                                                    brandValue: newValue || '',
                                                    brandInputValue: newValue || '',
                                                    showNewBrandField: false,
                                                    brandNewValue: ''
                                                });
                                            }
                                        }}
                                        onInputChange={(event, newInputValue) => {
                                            this.setState({
                                                brandInputValue: newInputValue
                                            });
                                        }}
                                        value={this.state.brandValue}
                                        inputValue={this.state.brandInputValue}
                                        className="autocomplete-dropdown"
                                        renderInput={(params) => <TextField {...params} inputProps={{
                                            ...params.inputProps
                                        }} label="Brand" autoComplete="new-password" variant="outlined"/>}
                                    />
                                    {this.state.showNewBrandField && (
                                        <TextField
                                            value={this.state.brandNewValue}
                                            onChange={(e) => this.setState({brandNewValue: e.target.value})}
                                            label="New Brand"
                                            variant="outlined"
                                            style={{width: '100%', marginBottom: 20}}
                                            inputProps={{maxLength: 200}}
                                        />
                                    )}

                                    <div style={{marginBottom: 20}}>
                                        Selected assemblies: {Object.keys(this.state.selectedAssemblies).length}
                                    </div>
                                    <div style={{marginBottom: 20, fontSize: '14px', color: '#666'}}>
                                        Leave categories empty to keep existing values. Only specified categories will be updated.
                                    </div>
                                    {this.state.savingCategory ? (
                                        <CircularProgress />
                                    ) : (
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={this.saveAssignCategory}
                                            className="success-button-lg"
                                        >
                                            Update Selected Assemblies
                                        </Button>
                                    )}
                                </div>
                            </DrawerMenuRight>

                            {this.state.assemblyMenuOpen ?
                                <DrawerMenuRight title={"New Assembly"} customWidth={400}
                                                 open={this.state.assemblyMenuOpen}
                                                 onClose={this.handleCloseAssemblyMenu}
                                                 hasUnsavedChanges={this.state.newAssemblyIsFG !== true}
                                                 onSubmit={() => this.state.newAssemblyIsFG ? this.createAssembly() : this.createSubAssembly()}
                                                 submitConfirmMessage="Are you sure you want to create this assembly?">
                                    <Checkbox onClick={(event) => {
                                        this.setState({newAssemblyIsFG: event.target.checked})
                                    }} checked={this.state.newAssemblyIsFG}/> Finished Good
                                    <br/>
                                    <br/>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={() => this.state.newAssemblyIsFG ? this.createAssembly() : this.createSubAssembly()}
                                        className="success-button-lg"
                                    >
                                        Next
                                    </Button>
                                </DrawerMenuRight>
                                : ""}
                            {this.state.editAssemblyOpen ?
                                <DrawerMenuRight title={"New Assembly"} customWidth={700}
                                                 open={this.state.editAssemblyOpen}
                                                 onClose={this.handleCloseEditAssembly}
                                                 hasUnsavedChanges={this.hasEditAssemblyUnsavedChanges()}
                                                 onSubmit={this.saveAssembly}
                                                 submitConfirmMessage="Are you sure you want to save this assembly?">
                                    <center>
                                        <Autocomplete autoHighlight
                                            id="ddlAssemblyFamily"
                                            style={{marginBottom: 20}}
                                            options={assemblyFamilyOptions}
                                            onChange={this.handleAssemblyFamilyChange}
                                            getOptionLabel={(option) => option.title}
                                            getOptionSelected={(option) => option.value === this.state.assemblyFamily}
                                            className="autocomplete-dropdown"
                                            renderInput={(params) => <TextField {...params} inputProps={{
                                                ...params.inputProps
                                            }} label="Assembly Family (optional)" autoComplete="new-password"
                                                                                variant="outlined"/>}
                                        />
                                        {this.state.assemblyFamily === 'New' ?
                                            <div>
                                                <TextField defaultValue=''
                                                        onChange={this.changeNewFamilyName} label={"New Family Name"}
                                                        variant="outlined"
                                                        style={{width: '24%', margin: '0 5px 20px 0'}}
                                                        inputProps={{maxLength: 50}}/>
                                                <TextField defaultValue=''
                                                        onChange={this.changeNewFamilyDescription}
                                                        label={"New Family Description"} variant="outlined"
                                                        style={{width: '70%', margin: '0 0 20px 5px'}}
                                                        inputProps={{maxLength: 500}}/>
                                            </div>
                                            : ""}
                                        
                                        {/* Part Number and Description on same line */}
                                        <TextField defaultValue={this.state.editingAssembly.assembly.assemblyId}
                                                onChange={this.changeAssemblyId} label={"Part Number"} variant="outlined"
                                                style={{width: '24%', margin: '0 5px 20px 0'}} inputProps={{maxLength: 50}}/>
                                        <TextField defaultValue={this.state.editingAssembly.assembly.description}
                                                onChange={this.changeDescription} label={"Description"}
                                                variant="outlined" style={{width: '70%', margin: '0 0 20px 5px'}}
                                                inputProps={{maxLength: 500}}/>
                                        
                                        {/* Revision and Revision Notes on same line */}
                                        <TextField defaultValue={this.state.editingAssembly.assembly.revision}
                                                onChange={this.changeRevision} label={"Revision"} variant="outlined"
                                                style={{width: '24%', margin: '0 5px 20px 0'}} inputProps={{maxLength: 5}}/>
                                        <TextField defaultValue={this.state.editingAssembly.assembly.revisionNotes}
                                                onChange={this.changeRevisionNotes} label={"Revision Notes"}
                                                variant="outlined" style={{width: '70%', margin: '0 0 20px 5px'}}
                                                inputProps={{maxLength: 500}}/>
                                        
                                        {/* Status, Shipping Cost, and MSRP on same line */}
                                        <FormControl style={{width: '32%', margin: '0 5px 20px 0'}} variant="outlined">
                                            <InputLabel id="assembly-status-label">Status</InputLabel>
                                            <Select
                                                value={this.state.editingAssembly.assembly.status ?? 0}
                                                style={{width: '100%'}}
                                                label="Status"
                                            >
                                                <MenuItem value={0}
                                                        onClick={() => this.handleAssemblyStatusChange(0)}>Standard</MenuItem>
                                                <MenuItem value={1}
                                                        onClick={() => this.handleAssemblyStatusChange(1)}>New
                                                    Product</MenuItem>
                                                <MenuItem value={2}
                                                        onClick={() => this.handleAssemblyStatusChange(2)}>Preorder
                                                    Phase</MenuItem>
                                                <MenuItem value={3}
                                                        onClick={() => this.handleAssemblyStatusChange(3)}>Future
                                                    Product</MenuItem>
                                                <MenuItem value={4}
                                                        onClick={() => this.handleAssemblyStatusChange(4)}>Updates</MenuItem>
                                            </Select>
                                        </FormControl>
                                        <TextField value={this.state.editingAssembly.assembly.shippingCost || ''}
                                                onChange={(event) => this.setState({editingAssembly: {...this.state.editingAssembly, assembly: {...this.state.editingAssembly.assembly, shippingCost: event.target.value}}})} label={"Shipping Cost"}
                                                variant="outlined" style={{width: '32%', margin: '0 5px 20px 5px'}}
                                                InputProps={{
                                                    startAdornment: <InputAdornment position="start">$</InputAdornment>
                                                }}/>
                                        <TextField value={this.state.editingAssembly.assembly.msrp || ''}
                                                onChange={(event) => this.setState({editingAssembly: {...this.state.editingAssembly, assembly: {...this.state.editingAssembly.assembly, msrp: event.target.value}}})} label={"MSRP"}
                                                variant="outlined" style={{width: '32%', margin: '0 0 20px 5px'}}
                                                InputProps={{
                                                    startAdornment: <InputAdornment position="start">$</InputAdornment>
                                                }}/>
                                        
                                        <Autocomplete autoHighlight
                                            id="ddlDiscountStrategy"
                                            style={{marginBottom: 20}}
                                            options={discountStrategyOptions}
                                            onChange={this.handleDiscountStrategyChange}
                                            getOptionLabel={(option) => option.title}
                                            getOptionSelected={(option) => option.value === this.state.discountStrategy}
                                            className="autocomplete-dropdown"
                                            renderInput={(params) => <TextField {...params} inputProps={{
                                                ...params.inputProps
                                            }} label="Load Discount Strategy" autoComplete="new-password"
                                                                                variant="outlined"/>}
                                        />
                                        <span style={{marginBottom: 15, display: 'block'}}>Current Strategy: {this.state.matchingDiscountStrategy ? this.state.matchingDiscountStrategy.name : 'Custom'}</span>
                                        
                                        {/* Discount Tiers on same line */}
                                        <TextField
                                            value={this.state.editingAssembly.assembly.discountTier1 < 1 ? this.state.editingAssembly.assembly.discountTier1 * 100 : this.state.editingAssembly.assembly.discountTier1}
                                            onChange={this.changeDiscountTier1} label={"Discount Tier 1"}
                                            variant="outlined" style={{width: '31%', margin: '0 5px 20px 0'}}
                                            InputProps={{
                                                endAdornment: <InputAdornment position="end">%</InputAdornment>
                                            }}/>
                                        <TextField
                                            value={this.state.editingAssembly.assembly.discountTier2 < 1 ? this.state.editingAssembly.assembly.discountTier2 * 100 : this.state.editingAssembly.assembly.discountTier2}
                                            onChange={this.changeDiscountTier2} label={"Discount Tier 2"}
                                            variant="outlined" style={{width: '31%', margin: '0 5px 20px 5px'}}
                                            InputProps={{
                                                endAdornment: <InputAdornment position="end">%</InputAdornment>
                                            }}/>
                                        <TextField
                                            value={this.state.editingAssembly.assembly.discountTier3 < 1 ? this.state.editingAssembly.assembly.discountTier3 * 100 : this.state.editingAssembly.assembly.discountTier3}
                                            onChange={this.changeDiscountTier3} label={"Discount Tier 3"}
                                            variant="outlined" style={{width: '31%', margin: '0 0 20px 5px'}}
                                            InputProps={{
                                                endAdornment: <InputAdornment position="end">%</InputAdornment>
                                            }}/>
                                        
                                        {this.state.savingAssembly === true ?
                                            <CircularProgress/>
                                            :
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                onClick={this.saveAssembly}
                                                className="success-button-lg"
                                            >
                                                Save
                                            </Button>
                                        }
                                        {this.state.savingAssembly !== true && editingAssembly.assembly.id !== '' ?
                                            <div>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={this.deleteAssembly}
                                                    className="delete-button-lg"
                                                    style={{margin: '20px 0'}}
                                                >
                                                    Delete
                                                </Button>
                                            </div>
                                            : ""}
                                    </center>
                                </DrawerMenuRight>
                                : ""}
                            {this.state.editSubAssemblyOpen ?
                                <DrawerMenuRight title={"New Subassembly"} customWidth={600}
                                                 open={this.state.editSubAssemblyOpen}
                                                 onClose={this.handleCloseEditSubAssembly}
                                                 hasUnsavedChanges={this.hasEditSubAssemblyUnsavedChanges()}
                                                 onSubmit={this.saveSubAssembly}
                                                 submitConfirmMessage="Are you sure you want to save this subassembly?">
                                    <center>
                                        {/* Part Number and Description on same line */}
                                        <TextField defaultValue={this.state.editingSubAssembly.subAssembly.subAssemblyId}
                                                onChange={this.changeSubAssemblyId} label={"Part Number"}
                                                variant="outlined"
                                                style={{width: '27%', margin: '0 5px 20px 0'}} inputProps={{maxLength: 50}}/>
                                        <TextField defaultValue={this.state.editingSubAssembly.subAssembly.description}
                                                onChange={this.changeSubDescription} label={"Description"}
                                                variant="outlined" style={{width: '67%', margin: '0 0 20px 5px'}}
                                                inputProps={{maxLength: 500}}/>
                                        
                                        {/* Revision and Revision Notes on same line */}
                                        <TextField defaultValue={this.state.editingSubAssembly.subAssembly.revision}
                                                onChange={this.changeSubRevision} label={"Revision"} variant="outlined"
                                                style={{width: '27%', margin: '0 5px 20px 0'}} inputProps={{maxLength: 5}}/>
                                        <TextField defaultValue={this.state.editingSubAssembly.subAssembly.revisionNotes}
                                                onChange={this.changeSubRevisionNotes} label={"Revision Notes"}
                                                variant="outlined" style={{width: '67%', margin: '0 0 20px 5px'}}
                                                inputProps={{maxLength: 500}}/>
                                        
                                        {this.state.savingSubAssembly === true ?
                                            <CircularProgress/>
                                            :
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                onClick={this.saveSubAssembly}
                                                className="success-button-lg"
                                            >
                                                Save
                                            </Button>
                                        }
                                        {this.state.savingSubAssembly !== true && editingSubAssembly.subAssembly.id !== '' ?
                                            <div>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={this.deleteSubAssembly}
                                                    className="delete-button-lg"
                                                    style={{margin: '20px 0'}}
                                                >
                                                    Delete
                                                </Button>
                                            </div>
                                            : ""}
                                    </center>
                                </DrawerMenuRight>
                                : ""}

                            {/* Category Edit Drawers */}
                            {this.state.editAssemblyTypeOpen ?
                                <DrawerMenuRight title="Edit Assembly Category (Primary)" open={this.state.editAssemblyTypeOpen}
                                                 onClose={() => this.setState({editAssemblyTypeOpen: false})} customWidth={500}
                                                 hasUnsavedChanges={this.state.newAssemblyTypeValue !== undefined && this.state.newAssemblyTypeValue !== ''}>
                                    <TextField
                                        placeholder="New Name" label="New Name"
                                        variant="outlined"
                                        fullWidth
                                        value={this.state.newAssemblyTypeValue}
                                        onChange={(event) => this.setState({newAssemblyTypeValue: event.target.value})}
                                        style={{marginBottom: 20}}
                                    />
                                    {this.state.savingCategory ?
                                        <CircularProgress />
                                        :
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={this.saveAssemblyType}
                                            className="success-button-lg"
                                        >
                                            Save
                                        </Button>
                                    }
                                </DrawerMenuRight>
                                : ""}

                            {this.state.editManufacturerForOpen ?
                                <DrawerMenuRight title="Edit Assembly Category (Secondary)" open={this.state.editManufacturerForOpen}
                                                 onClose={() => this.setState({editManufacturerForOpen: false})} customWidth={500}
                                                 hasUnsavedChanges={this.state.newManufacturerForValue !== undefined && this.state.newManufacturerForValue !== ''}>
                                    <TextField
                                        placeholder="New Name" label="New Name"
                                        variant="outlined"
                                        fullWidth
                                        value={this.state.newManufacturerForValue}
                                        onChange={(event) => this.setState({newManufacturerForValue: event.target.value})}
                                        style={{marginBottom: 20}}
                                    />
                                    {this.state.savingCategory ?
                                        <CircularProgress />
                                        :
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={this.saveManufacturerFor}
                                            className="success-button-lg"
                                        >
                                            Save
                                        </Button>
                                    }
                                </DrawerMenuRight>
                                : ""}

                            {this.state.editTertiaryTypeOpen ?
                                <DrawerMenuRight title="Edit Assembly Category (Tertiary)" open={this.state.editTertiaryTypeOpen}
                                                 onClose={() => this.setState({editTertiaryTypeOpen: false})} customWidth={500}
                                                 hasUnsavedChanges={this.state.newTertiaryTypeValue !== undefined && this.state.newTertiaryTypeValue !== ''}>
                                    <TextField
                                        placeholder="New Name" label="New Name"
                                        variant="outlined"
                                        fullWidth
                                        value={this.state.newTertiaryTypeValue}
                                        onChange={(event) => this.setState({newTertiaryTypeValue: event.target.value})}
                                        style={{marginBottom: 20}}
                                    />
                                    {this.state.savingCategory ?
                                        <CircularProgress />
                                        :
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={this.saveTertiaryType}
                                            className="success-button-lg"
                                        >
                                            Save
                                        </Button>
                                    }
                                </DrawerMenuRight>
                                : ""}
                        </div>
                        <center>
                            <TablePagination
                                rowsPerPageOptions={[50, 100, 200, 500]}
                                colSpan={50}
                                count={displayAssemblies.length}
                                rowsPerPage={this.state.rowsPerPage}
                                page={this.state.page}
                                slotProps={{
                                    select: {
                                        'aria-label': 'rows per page',
                                    },
                                    actions: {
                                        showFirstButton: true,
                                        showLastButton: true,
                                        slots: {
                                            firstPageIcon: FirstPageIcon,
                                            lastPageIcon: LastPageIcon,
                                            nextPageIcon: ChevronRightIcon,
                                            backPageIcon: ChevronLeftIcon,
                                        },
                                    },
                                }}
                                onChangePage={this.handleChangePage}
                                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                            />
                        </center>
                    </div>
                </div>
            </DashboardTemplate>
        );
    }
}

let globalProps;

AdminAssemblies.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AdminAssemblies);